/* bb-budget.ui.js — DROP-IN REPLACEMENT (trimmed + safer wiring, keeps behavior) */
;(() => {
  "use strict";

  // Always create namespace so it "exists"
  window.TYBH = window.TYBH || {};
  const TYBH = window.TYBH;

  // DOM helper
  // This file uses $("id") heavily. Ensure it exists so the whole UI does not crash on load.
  const $ = (id) => {
    try { return document.getElementById(id); } catch(_e) { return null; }
  };

  // Prevent a complete second boot, but do not poison the namespace when
  // Shopify loads this file before util/core. A later ordered reload must be
  // allowed to initialize the real UI.
  TYBH.ui = TYBH.ui || {};
  if (TYBH.ui._scriptLoaded && typeof TYBH.ui.openEmbedded === "function") return;

  const U = TYBH.util;
  const C = TYBH.core;
  if (!U || !C) {
    TYBH.ui._dependencyMissing = true;
    console.error(
      "Budget Hub: util/core missing. Load order must be: bb-budget.util.js -> bb-budget.core.js -> bb-budget.ui.js"
    );
    return;
  }
  TYBH.ui._dependencyMissing = false;
  TYBH.ui._scriptLoaded = true;

  // Safe number cast helper (prevents num_ undefined crashes)
  // Define on window as well to survive any bundling / scoping changes.
  const num_ = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  try{
    if(typeof window !== 'undefined'){
      window.num_ = window.num_ || num_;
      window.numb = window.numb || num_;
    }
  }catch(_e){}



  // ===== Cloud backend (shares SLB login token) =====
  const CLOUD = {
    url: null,
    token: "",
    callsign: "",
    isAdmin: false,
    targetCallsign: "",   // admin: view as
    profileKey: "",
    lastLoadedAt: 0,
    lastSavedAt: 0,
    saving: false,
    saveTimer: null,
    lastSavedJson: "",
    loadedOnce: false
  };


  function isSlbEmbedded_(){
    try{
      const root = document.getElementById("tyBudgetHub");
      return !!(root && root.getAttribute("data-slb-embedded") === "1");
    }catch(_e){ return false; }
  }

  let _embeddedLoadPromise = null;
  let _embeddedSessionToken = "";

  function cloudEls_(){
    return {
      card: $("cloudCard"),
      status: $("cloudStatus"),
      backend: $("cloudBackend"),
      backendInput: $("cloudBackendInput"),
      msg: $("cloudMsg"),
      loginRow: $("cloudLoginRow"),
      callsign: $("cloudCallsign"),
      pin: $("cloudPin"),
      saveBtn: $("cloudSaveBtn"),
      reloadBtn: $("cloudReloadBtn"),
      logoutBtn: $("cloudLogoutBtn"),
      adminRow: $("cloudAdminRow"),
      adminTools: $("cloudAdminTools"),
      viewCallsign: $("cloudViewCallsign"),
      shareKey: $("cloudShareKey"),
      shareCallsigns: $("cloudShareCallsigns")
    };
  }

  function slbResolveWebappUrl_(){
    // Same resolution order as SLB (more reliable than a hardcoded default)
    // 1) window.SLB_WEBAPP_URL
    // 2) localStorage 'slb_webapp_url'
    // 3) URL query ?slb_backend=... (or ?backend=...)
    // 4) baked fallback (same as SLB bundle)
    try{
      if(typeof window!== 'undefined' && window.SLB_WEBAPP_URL && String(window.SLB_WEBAPP_URL).trim()){
        return String(window.SLB_WEBAPP_URL).trim();
      }
    }catch(_e){}
    try{
      const v = localStorage.getItem('slb_webapp_url');
      if(v && String(v).trim()) return String(v).trim();
    }catch(_e){}
    try{
      const u = new URL(location.href);
      const q = u.searchParams.get('slb_backend') || u.searchParams.get('backend');
      if(q && String(q).trim()){
        const vv = String(q).trim();
        try{ localStorage.setItem('slb_webapp_url', vv); }catch(_e){}
        return vv;
      }
    }catch(_e){}
    return "https://script.google.com/macros/s/AKfycbwFTGsr-IfaETXvCC4IfTSHTJ3ESkNn46797KvI-hp-n2OIDhlnR7104sfZpheu0YzXCA/exec";
  }

  // Phase 5 transport is handled exclusively by SLBPostBridge.


  function tywApi_(action, args, opts){
    opts = opts || {};
    args = args || {};
    const requestId = (opts.requestId ? String(opts.requestId) : ("p5b_" + Date.now() + "_" + Math.random().toString(16).slice(2)));
    const token = (CLOUD.token || (window.SLB_SESSION&&window.SLB_SESSION.get?String(window.SLB_SESSION.get("token")||""):"") || (sessionStorage.getItem("tyw_token")||""));
    const payload = { requestId, action, token, args };

    const timeoutMs = (function(){
      const a = String(action||"");
      if(a === "budgetPutParts") return 90000;
      if(a === "budgetPut" || a === "budgetGet") return 120000;
      if(a === "budgetEnsureProfile" || a === "budgetDiag") return 60000;
      return 45000;
    })();

    // V4.7: inside normal SLB, Budget uses the same shared RPC owner as every
    // other feature. This gives it route-aware READ coalescing, shared write
    // single-flight, session ownership and the common secure transport.
    try{
      const app=window.SLB_APP||null;
      const fn=app&&(typeof app.__realRpc==="function"?app.__realRpc:(typeof app.rpc==="function"?app.rpc:null));
      if(fn){
        return Promise.resolve(fn.call(app, action, args, Object.assign({}, opts, {
          requestId: requestId,
          timeoutMs: timeoutMs
        })));
      }
    }catch(_eShared){}

    // Standalone/recovery mode: preserve the direct secure bridge fallback.
    if(!CLOUD.url){
      return Promise.reject(new Error("Backend URL not set. Open any SLB page once, or add ?slb_backend=YOUR_WEBAPP_URL to this page."));
    }
    if(!window.SLBPostBridge || typeof window.SLBPostBridge.call !== "function"){
      return Promise.reject(new Error("Secure SLB transport did not load. Hard refresh and try again."));
    }
    return window.SLBPostBridge.call(CLOUD.url, payload, {
      timeoutMs: timeoutMs,
      action: String(action || "")
    });
  }

  function b64WebToUtf8_(b64){
    try{
      let s = String(b64 || "").trim();
      if(!s) return "";
      s = s.replace(/-/g, "+").replace(/_/g, "/");
      // add padding
      const pad = s.length % 4;
      if(pad === 2) s += "==";
      else if(pad === 3) s += "=";
      else if(pad === 1) s += "===";

      const bin = atob(s);
      const bytes = new Uint8Array(bin.length);
      for(let i=0;i<bin.length;i++) bytes[i] = bin.charCodeAt(i) & 0xff;
      if(typeof TextDecoder !== "undefined"){
        return new TextDecoder("utf-8").decode(bytes);
      }
      // fallback (older browsers)
      let str = "";
      for(let i=0;i<bytes.length;i++) str += String.fromCharCode(bytes[i]);
      try{ return decodeURIComponent(escape(str)); }catch(_e){ return str; }
    }catch(_e){
      return "";
    }
  }


// Encode UTF-8 string -> websafe base64 (no padding)
function utf8ToB64Web_(str){
  try{
    str = String(str || "");
    if(!str) return "";
    let bytes;
    if(typeof TextEncoder !== "undefined"){
      bytes = new TextEncoder().encode(str);
    }else{
      const esc = unescape(encodeURIComponent(str));
      bytes = new Uint8Array(esc.length);
      for(let i=0;i<esc.length;i++) bytes[i] = esc.charCodeAt(i) & 0xff;
    }

    let bin = "";
    const step = 0x4000;
    for(let i=0;i<bytes.length;i+=step){
      bin += String.fromCharCode.apply(null, bytes.subarray(i, i+step));
    }
    return btoa(bin).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/g,"");
  }catch(_e){
    return "";
  }
}

  function cloudSetStatus_(s){
    const el = cloudEls_().status;
    if(el) el.textContent = String(s||"");
  }
  function cloudSetMsg_(s, kind){
    const el = cloudEls_().msg;
    if(!el) return;
    el.textContent = String(s||"");
    el.classList.remove("ok","warn","bad");
    if(kind) el.classList.add(kind);
  }
  function cloudShowLogin_(show){
    const E = cloudEls_();
    if(isSlbEmbedded_()) show = false;
    if(E.loginRow) E.loginRow.style.display = show ? "" : "none";
  }
  function cloudShowAdmin_(show){
    const E = cloudEls_();
    if(E.adminRow) E.adminRow.style.display = show ? "" : "none";
    if(E.adminTools) E.adminTools.style.display = show ? "" : "none";
  }
  function cloudEnableButtons_(enabled){
    const E = cloudEls_();
    if(E.saveBtn) E.saveBtn.disabled = !enabled;
    if(E.reloadBtn) E.reloadBtn.disabled = !enabled;
    if(E.logoutBtn) E.logoutBtn.disabled = !enabled;
  }

  function cloudSyncBackendUi_(){
    const E = cloudEls_();
    const url = String(CLOUD.url||"").trim();
    if(E.backend) E.backend.textContent = url ? url : "—";
    if(E.backendInput && !E.backendInput.value) E.backendInput.value = url;
  }

  function cloudReadSession_(){
    let state = null, hub = null;
    try{ state = window.SLB_APP && window.SLB_APP.S ? window.SLB_APP.S : null; }catch(_e0){ state = null; }
    try{ hub = window.SLB_SESSION && typeof window.SLB_SESSION.peek==='function' ? window.SLB_SESSION.peek() : null; }catch(_eH){ hub=null; }
    try{
      CLOUD.token = String((hub&&hub.token) || (state && state.token) || sessionStorage.getItem("tyw_token") || "").trim();
      CLOUD.callsign = String((hub&&hub.callsign) || (state && state.callsign) || sessionStorage.getItem("tyw_callsign") || "").trim().toUpperCase();
      const adminStored = String(sessionStorage.getItem("tyw_isAdmin")||"0") === "1";
      const modStored = String(sessionStorage.getItem("tyw_isModerator")||"0") === "1";
      CLOUD.isAdmin = !!((hub&&hub.isAdminOrMod) || (state && (state.isAdmin || state.isModerator || state.isAdminOrMod)) || adminStored || modStored);
    }catch(_e){
      CLOUD.token = String((hub&&hub.token) || (state && state.token) || "").trim();
      CLOUD.callsign = String((hub&&hub.callsign) || (state && state.callsign) || "").trim().toUpperCase();
      CLOUD.isAdmin = !!((hub&&hub.isAdminOrMod) || (state && (state.isAdmin || state.isModerator || state.isAdminOrMod)));
    }
  }


  // Optional: auto-login using SLB "Remember login" values (cross-page)
  let _cloudAutoLoginTried = false;
  async function cloudAutoLoginFromSLB_(){
    if(_cloudAutoLoginTried) return;
    _cloudAutoLoginTried = true;
    if(CLOUD.token) return;
    let saved = null;
    try{
      saved = JSON.parse(localStorage.getItem("slb_saved_login_v1") || "null");
    }catch(_e){ saved = null; }
    const callsign = String(saved && saved.callsign ? saved.callsign : "").trim().toUpperCase();
    const pin = String(saved && saved.pin ? saved.pin : "").trim();
    if(!callsign || !pin) return;
    try{
      const E = cloudEls_();
      if(E.callsign && !E.callsign.value) E.callsign.value = callsign;
      if(E.pin && !E.pin.value) E.pin.value = pin;
    }catch(_e){}
    try{ cloudSetMsg_("Auto-login from SLB saved login…", "warn"); }catch(_e){}
    try{ await cloudLogin(); }catch(_e){}
  }

  function cloudApplyDashboard_(dash){
    try{
      if(dash && dash.profile){
        const p = dash.profile;
        CLOUD.callsign = String(p.callsign||"").trim().toUpperCase();
        CLOUD.isAdmin = !!p.isAdmin;
        if(window.SLB_SESSION&&typeof window.SLB_SESSION.accept==='function') window.SLB_SESSION.accept({token:CLOUD.token,callsign:CLOUD.callsign,displayName:String(p.displayName||""),isAdmin:!!p.isAdmin,isModerator:!!p.isModerator,canCreatePouches:!!p.canCreatePouches},{persistSession:true,persistShared:!!CLOUD.token});
        else{
          sessionStorage.setItem("tyw_callsign", CLOUD.callsign);
          sessionStorage.setItem("tyw_displayName", String(p.displayName||""));
          sessionStorage.setItem("tyw_isAdmin", CLOUD.isAdmin ? "1" : "0");
          sessionStorage.setItem("tyw_isModerator", (p.isModerator ? "1" : "0"));
        }
      }
    }catch(_e){}
  }

  async function cloudLogin(){
    const E = cloudEls_();
    const callsign = String((E.callsign && E.callsign.value) ? E.callsign.value : "").trim().toUpperCase();
    const pin = String((E.pin && E.pin.value) ? E.pin.value : "").trim();
    if(!callsign || !pin){
      cloudSetMsg_("Enter callsign + PIN.", "warn");
      return;
    }
    cloudSetMsg_("Logging in…");
    try{
      const out = await tywApi_("loginBundle", { callsign, pin });
      if(!out || !out.token){
        cloudSetMsg_("Login failed.", "bad");
        return;
      }
      CLOUD.token = String(out.token||"");
      if(window.SLB_SESSION&&typeof window.SLB_SESSION.accept==='function') window.SLB_SESSION.accept({token:CLOUD.token,callsign:callsign},{persistSession:true,emit:false});
      else sessionStorage.setItem("tyw_token", CLOUD.token);
      cloudApplyDashboard_(out.dash||null);
      cloudReadSession_();
      cloudSetMsg_("Logged in.", "ok");
      cloudShowLogin_(false);
      cloudShowAdmin_(!!CLOUD.isAdmin);
      await cloudLoadFromCloud_();
    }catch(e){
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }
  }

  function cloudLogout(){
    if(isSlbEmbedded_()){
      cloudSetMsg_("BB Budget uses your active SLB login. Use the main SLB Exit button to log out.", "warn");
      return;
    }
    try{
      sessionStorage.removeItem("tyw_token");
      sessionStorage.removeItem("tyw_callsign");
      sessionStorage.removeItem("tyw_displayName");
      sessionStorage.removeItem("tyw_isAdmin");
      sessionStorage.removeItem("tyw_isModerator");
    }catch(_e){}
    CLOUD.token = "";
    CLOUD.loadedOnce = false;
    CLOUD.callsign = "";
    CLOUD.isAdmin = false;
    CLOUD.viewAs = "";
    cloudSetStatus_("Not logged in.", "warn");
    cloudSetMsg_("Logged out.", "ok");
    cloudShowLogin_(true);
    cloudShowAdmin_(false);
    cloudEnableButtons_(false);
  }

  function cloudSetBackend(){
    const E = cloudEls_();
    const url = String((E.backendInput && E.backendInput.value) ? E.backendInput.value : "").trim();
    if(!url){
      cloudSetMsg_("Paste your Apps Script Web app /exec URL.", "warn");
      return;
    }
    CLOUD.url = url;
    try{ localStorage.setItem('slb_webapp_url', url); }catch(_e){}
    cloudSyncBackendUi_();
    cloudSetMsg_("Backend URL saved.", "ok");
  }

  async function cloudPing(){
    cloudSyncBackendUi_();
    if(!CLOUD.url){
      cloudSetMsg_("Backend URL not set.", "bad");
      return;
    }
    cloudSetMsg_("Pinging backend…");
    try{
      const out = await tywApi_("ping", {});
      const b = (out && out.build) ? String(out.build) : "?";
      const t = (out && out.serverTime) ? String(out.serverTime) : "";
      cloudSetMsg_("Backend OK. Build="+b+(t?(" | "+t):"")+"", "ok");
    }catch(e){
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }
  }

  function cloudPickTargetCallsign_(){
    // admin view override stored in sessionStorage
    try{
      const t = String(sessionStorage.getItem("tybh_admin_target_callsign")||"").trim().toUpperCase();
      if(t) CLOUD.targetCallsign = t;
    }catch(_e){}
  }

  function cloudApplySnapshot_(snap){
    if(!snap || !snap.data) return false;
    try{
      // restore state fields (same as restoreLastSession) but treat as clean
      state.settings = snap.data.settings || {};
      state.rules = snap.data.rules || {};
      state.accounts = snap.data.accounts || [];
      state.bills = snap.data.bills || [];
      state.budgets = snap.data.budgets || [];
      state.goals = snap.data.goals || [];
      state.categories = snap.data.categories || [];
      state.grow = snap.data.grow || {};
      state.move = snap.data.move || {};
      state.tx = snap.data.tx || [];
      state.loaded = true;
      state._isDemo = false;

      META.fileName = (snap.meta && snap.meta.fileName) ? snap.meta.fileName : (META.fileName || "");
      META.dirty = false;
      META.lastExportTs = (snap.meta && snap.meta.lastExportTs) ? snap.meta.lastExportTs : 0;
      META.cloudSavedTs = Date.now();

      // Keep a local snapshot mirror for offline
      try{
        localStorage.setItem(LS_KEY, JSON.stringify(snap));
      }catch(_e){}

      state._restoreOffered = false;
      try{ dismissRestore(); }catch(_e){}
      setDemoMode(false);

      afterLoad();
      updateStatusStrip();
      return true;
    }catch(e){
      console.error(e);
      return false;
    }
  }

  async function cloudLoadFromCloud_(){
    cloudReadSession_();
    cloudPickTargetCallsign_();
    if(!CLOUD.token){
      cloudSetStatus_("Not logged in.");
      cloudShowLogin_(true);
      cloudShowAdmin_(false);
      cloudEnableButtons_(false);
      return;
    }
    cloudEnableButtons_(true);
    cloudShowLogin_(false);
    cloudShowAdmin_(!!CLOUD.isAdmin);

    const viewNote = (CLOUD.isAdmin && CLOUD.targetCallsign) ? (" (viewing " + CLOUD.targetCallsign + ")") : "";
    cloudSetStatus_("Loading…" + viewNote);

    try{
      const baseArgs = (CLOUD.isAdmin && CLOUD.targetCallsign) ? { targetCallsign: CLOUD.targetCallsign } : {};

      // Step 0: ensure profile sheet exists (first-time users need a tab)
      try{ await tywApi_("budgetEnsureProfile", baseArgs); }catch(_e){}

      // Step 1: meta (fast) — avoids huge JSONP payloads.
      const meta = await tywApi_("budgetGet", Object.assign({}, baseArgs, { mode: "meta" }));
      CLOUD.profileKey = String(meta && meta.profileKey ? meta.profileKey : "");
      CLOUD.lastLoadedAt = num_(meta && meta.updatedAt ? meta.updatedAt : 0) || 0;
      const partsTotal = num_(meta && meta.parts ? meta.parts : 0) || 0;

      if(partsTotal <= 0){
        // No cloud data yet: keep current local state, but show ready status
        CLOUD.loadedOnce = true;
        cloudSetStatus_("Ready (empty). Profile: " + (CLOUD.profileKey || "—") + viewNote);
        cloudSetMsg_("Cloud is empty for this profile. Import CSV or start adding transactions, then it will auto-save.", "warn");
        return;
      }

      // Step 2: fetch JSON in small parts (robust for large profiles)
      const batch = 6;
      const pieces = [];
      let got = 0;

      for(let p=1; p<=partsTotal; p+=batch){
        const lim = Math.min(batch, partsTotal - p + 1);
        cloudSetStatus_("Loading…" + viewNote + " " + Math.min(p + lim - 1, partsTotal) + "/" + partsTotal);
        const pr = await tywApi_("budgetGet", Object.assign({}, baseArgs, { mode: "part", start: p, limit: lim }));
        const arr = (pr && pr.chunksB64 && Array.isArray(pr.chunksB64)) ? pr.chunksB64 : [];
        for(let i=0;i<arr.length;i++){
          const b64 = arr[i];
          if(!b64) { pieces.push(""); continue; }
          pieces.push(b64WebToUtf8_(b64));
        }
        got += arr.length;
      }

      const rawJson = pieces.join("");
      let snap = null;
      try{ snap = JSON.parse(String(rawJson)); }catch(_e){ snap = null; }
      if(snap && snap.data){
        cloudApplySnapshot_(snap);
        CLOUD.loadedOnce = true;
        cloudSetStatus_("Loaded. Profile: " + (CLOUD.profileKey || "—") + viewNote);
        cloudSetMsg_("", "");
        return;
      }

      // If parse failed, fall back to legacy full-get (some environments might still be on older backend)
      const out = await tywApi_("budgetGet", baseArgs);
      CLOUD.profileKey = String(out && out.profileKey ? out.profileKey : CLOUD.profileKey);
      CLOUD.lastLoadedAt = num_(out && out.updatedAt ? out.updatedAt : CLOUD.lastLoadedAt) || 0;

      let legacyRaw = "";
      try{
        if(out && String(out.encoding||"") === "b64" && out.jsonB64){
          legacyRaw = b64WebToUtf8_(out.jsonB64);
        }else{
          legacyRaw = String(out && out.json ? out.json : "");
        }
      }catch(_e){ legacyRaw = String(out && out.json ? out.json : ""); }

      let snap2 = null;
      try{ snap2 = JSON.parse(String(legacyRaw||"")); }catch(_e){ snap2 = null; }
      if(snap2 && snap2.data){
        cloudApplySnapshot_(snap2);
        CLOUD.loadedOnce = true;
        cloudSetStatus_("Loaded. Profile: " + (CLOUD.profileKey || "—") + viewNote);
        cloudSetMsg_("", "");
        return;
      }

      cloudSetStatus_("Cloud load failed.");
      cloudSetMsg_("Cloud data could not be parsed.", "bad");
    }catch(e){
      cloudSetStatus_("Cloud load failed.");
      const baseMsg = String(e && e.message ? e.message : e);
      cloudSetMsg_(baseMsg, "bad");

      // Auto diagnostic (helps distinguish backend errors vs JSONP/size issues)
      try{
        const diagArgs = (CLOUD.isAdmin && CLOUD.targetCallsign) ? { targetCallsign: CLOUD.targetCallsign } : {};
        const d = await tywApi_("budgetDiag", diagArgs);
        if(d){
          const line = "Diag: ssId=" + (d.ssId||"?") + ", profileKey=" + (d.profileKey||"?") + ", sheet=" + (d.profileSheetName||"?") + ", exists=" + (d.profileSheetExists?"Y":"N") + ", lastRow=" + (d.profileLastRow||0);
          cloudSetMsg_(baseMsg + "\n" + line, "bad");
        }
      }catch(_e){}
      // fall back to login if session expired
      if(String(e && e.message || "").toLowerCase().indexOf("session expired") >= 0){
        try{ sessionStorage.removeItem("tyw_token"); }catch(_e){}
        CLOUD.token = "";
        cloudShowLogin_(true);
        cloudEnableButtons_(false);
      }
    }
  }

  function scheduleCloudSave_(){
    if(state._isDemo) return;
    if(!CLOUD.token) return;
    if(CLOUD.saveTimer) clearTimeout(CLOUD.saveTimer);
    CLOUD.saveTimer = setTimeout(()=>{ cloudSaveNow(false); }, 1800);
  }




  async function cloudSaveNow(force){
    const __forceSave = (force !== false);
    cloudReadSession_();
    const viewNote = (CLOUD.isAdmin && CLOUD.targetCallsign) ? (" (viewing " + CLOUD.targetCallsign + ")") : "";

    if(!CLOUD.token){
      cloudSetMsg_("Not logged in.", "warn");
      return;
    }
    if(CLOUD.saving) return;

    // Only save when dirty (auto). Manual Save now forces save even if not dirty.
    if(!META.dirty && !__forceSave) return;

    try{
      const snap = safeSnapshotPayload();
      const json = JSON.stringify(snap);
      if(!json) return;
      if(json === CLOUD.lastSavedJson){
        META.dirty = false;
        updateStatusStrip();
        return;
      }

      CLOUD.saving = true;
      cloudSetStatus_("Saving…" + viewNote);
      cloudSetMsg_("");

      const baseArgs = (CLOUD.isAdmin && CLOUD.targetCallsign) ? { targetCallsign: CLOUD.targetCallsign } : {};

      // Ensure profile + sheet exists (important for first-time users)
      try{ await tywApi_("budgetEnsureProfile", baseArgs); }catch(_e){}

      const v = snap.v || 0;

      
let out = null;

// Always use chunked writes with base64-encoded chunks.
// Use small chunks to avoid Error 400 (URL too long) on JSONP GET.
// Also retry with even smaller chunks if we still hit 400/network errors.
const chunkSizes = [1200, 800, 600, 400]; // raw JSON chars per chunk
let last = null;
let lastErr = null;

for(let attempt=0; attempt<chunkSizes.length; attempt++){
  const maxChunk = chunkSizes[attempt];
  last = null;
  lastErr = null;

  const partsTotal = Math.max(1, Math.ceil(json.length / maxChunk));

  try{
    for(let i=0;i<partsTotal;i++){
      const chunk = json.slice(i*maxChunk, (i+1)*maxChunk);
      const chunkB64 = utf8ToB64Web_(chunk);
      cloudSetStatus_("Saving…" + viewNote + " " + (i+1) + "/" + partsTotal + (attempt ? (" (retry " + (attempt+1) + ")") : ""));
      last = await tywApi_("budgetPutParts", Object.assign({}, baseArgs, {
        partNo: i + 1,
        partsTotal: partsTotal,
        chunkB64: chunkB64,
        v: v,
        reset: (i === 0),
        finalize: (i === partsTotal - 1)
      }));
    }
    out = last || {};
    lastErr = null;
    break; // success
  }catch(e){
    lastErr = e;
    const em = String(e && e.message ? e.message : e);
    // If the server rejects the URL length (400) or the browser treats it as a network error,
    // retry with a smaller chunk size.
    if(em.toLowerCase().indexOf('bad request') >= 0 || em.toLowerCase().indexOf('network error') >= 0){
      cloudSetMsg_("Save retry: chunk too large. Trying smaller…", "warn");
      continue;
    }
    throw e;
  }
}

if(lastErr){
  throw lastErr;
}
CLOUD.lastSavedAt = num_(out && out.updatedAt ? out.updatedAt : Date.now()) || Date.now();
      CLOUD.lastSavedJson = json;

      META.dirty = false;
      META.cloudSavedTs = CLOUD.lastSavedAt;
      updateStatusStrip();

      const pk = String(out && out.profileKey ? out.profileKey : (CLOUD.profileKey || "")) || "—";
      cloudSetStatus_("Saved. Profile: " + pk + viewNote);
      cloudSetMsg_("Cloud saved: " + fmtDT(CLOUD.lastSavedAt), "ok");
    }catch(e){
      cloudSetStatus_("Save failed." + viewNote);
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }finally{
      CLOUD.saving = false;
    }
  }

  async function cloudReload(){
    if(META.dirty){
      cloudSetMsg_("You have unsaved changes. Save first, then reload.", "warn");
      return;
    }
    await cloudLoadFromCloud_();
  }

  async function cloudViewAs(){
    cloudReadSession_();
    if(!CLOUD.isAdmin){
      cloudSetMsg_("Admin only.", "warn");
      return;
    }
    const E = cloudEls_();
    const t = String((E.viewCallsign && E.viewCallsign.value) ? E.viewCallsign.value : "").trim().toUpperCase();
    if(!t){
      cloudSetMsg_("Enter a callsign to view.", "warn");
      return;
    }
    try{ sessionStorage.setItem("tybh_admin_target_callsign", t); }catch(_e){}
    CLOUD.targetCallsign = t;
    await cloudLoadFromCloud_();
  }

  async function cloudCreateTab(){
    cloudReadSession_();
    if(!CLOUD.isAdmin){
      cloudSetMsg_("Admin only.", "warn");
      return;
    }
    const E = cloudEls_();
    const t = String((E.viewCallsign && E.viewCallsign.value) ? E.viewCallsign.value : (CLOUD.targetCallsign||""))
      .trim().toUpperCase();
    if(!t){
      cloudSetMsg_("Enter a callsign in Admin: View callsign, then click Init Profile.", "warn");
      return;
    }
    cloudSetMsg_("Initializing profile…");
    try{
      const out = await tywApi_("budgetEnsureProfile", { targetCallsign: t });
      const pk = String(out && out.profileKey ? out.profileKey : "").trim() || "—";
      const sh = String(out && out.sheetName ? out.sheetName : "").trim() || "—";
      cloudSetMsg_("OK. Profile ready for "+t+". ProfileKey="+pk+" | Store="+sh, "ok");
    }catch(e){
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }
  }

  async function cloudWipeProfile(){
    cloudReadSession_();
    if(!CLOUD.token){ cloudSetMsg_("Not logged in.", "warn"); return; }

    const E = cloudEls_();
    let t = (CLOUD.callsign || "").toUpperCase();
    if(CLOUD.isAdmin){
      t = String((E.viewCallsign && E.viewCallsign.value) ? E.viewCallsign.value : (CLOUD.targetCallsign||CLOUD.callsign||""))
        .trim().toUpperCase();
      if(!t){ cloudSetMsg_("Enter a callsign in Admin: View callsign, then click Wipe Cloud.", "warn"); return; }
    }

    const who = (CLOUD.isAdmin && t && t !== (CLOUD.callsign||"").toUpperCase()) ? t : (CLOUD.callsign||"").toUpperCase();
    if(!confirm("Wipe cloud data for " + who + "? This removes the saved cloud snapshot for this profile.")) return;

    const baseArgs = (CLOUD.isAdmin && t && t !== (CLOUD.callsign||"").toUpperCase()) ? { targetCallsign: t } : {};
    const viewNote = (CLOUD.isAdmin && baseArgs.targetCallsign) ? (" (viewing " + baseArgs.targetCallsign + ")") : "";

    cloudSetStatus_("Wiping cloud…" + viewNote);
    cloudSetMsg_("");
    try{
      const out = await tywApi_("budgetWipeProfile", baseArgs);
      CLOUD.lastSavedJson = "";
      CLOUD.lastSavedAt = 0;
      META.cloudSavedTs = 0;
      META.dirty = false;
      updateStatusStrip();

      const pk = String(out && out.profileKey ? out.profileKey : "").trim() || "—";
      cloudSetStatus_("Cloud wiped. Profile: " + pk + viewNote);
      cloudSetMsg_("Cloud wiped for " + who + ".", "ok");

      // Refresh view (shows empty state)
      try{ await cloudLoadFromCloud_(); }catch(_e){}
    }catch(e){
      cloudSetStatus_("Wipe failed." + viewNote);
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }
  }

  async function cloudReplaceCloud(){
    cloudReadSession_();
    if(!CLOUD.token){ cloudSetMsg_("Not logged in.", "warn"); return; }

    const E = cloudEls_();
    let t = (CLOUD.callsign || "").toUpperCase();
    if(CLOUD.isAdmin){
      t = String((E.viewCallsign && E.viewCallsign.value) ? E.viewCallsign.value : (CLOUD.targetCallsign||CLOUD.callsign||""))
        .trim().toUpperCase();
      if(!t){ cloudSetMsg_("Enter a callsign in Admin: View callsign, then click Replace Cloud.", "warn"); return; }
    }

    const who = (CLOUD.isAdmin && t && t !== (CLOUD.callsign||"").toUpperCase()) ? t : (CLOUD.callsign||"").toUpperCase();
    if(!confirm("Replace cloud data for " + who + " with the CURRENT file? (Wipe cloud first, then save now)")) return;

    const baseArgs = (CLOUD.isAdmin && t && t !== (CLOUD.callsign||"").toUpperCase()) ? { targetCallsign: t } : {};
    const viewNote = (CLOUD.isAdmin && baseArgs.targetCallsign) ? (" (viewing " + baseArgs.targetCallsign + ")") : "";

    try{
      cloudSetStatus_("Replacing cloud…" + viewNote);
      cloudSetMsg_("");
      await tywApi_("budgetWipeProfile", baseArgs);
      CLOUD.lastSavedJson = ""; // force next save
      META.dirty = true;        // allow auto-save to proceed too
      await cloudSaveNow(true);
      cloudSetMsg_("Cloud replaced for " + who + ".", "ok");
    }catch(e){
      cloudSetStatus_("Replace failed." + viewNote);
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }
  }

  async function cloudDiag(){
    cloudReadSession_();
    if(!CLOUD.isAdmin){
      cloudSetMsg_("Admin only.", "warn");
      return;
    }
    const E = cloudEls_();
    const t = String((E.viewCallsign && E.viewCallsign.value) ? E.viewCallsign.value : (CLOUD.targetCallsign||""))
      .trim().toUpperCase();
    if(!t){
      cloudSetMsg_("Enter a callsign in Admin: View callsign, then click Diag.", "warn");
      return;
    }
    cloudSetMsg_("Running diag…");
    try{
      const out = await tywApi_("budgetDiag", { targetCallsign: t });
      // show as a single line (safe for the small status area)
      const parts = [];
      for(const k of ["ssId","profileKey","sheet","exists","maxRows","metaUpdatedAt","partsTotal","accessRole","accessPk"]){
        if(out && out[k] != null) parts.push(k+"="+out[k]);
      }
      cloudSetMsg_("Diag: "+parts.join(" | "), "ok");
    }catch(e){
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }
  }

  async function cloudSetShare(){
    cloudReadSession_();
    if(!CLOUD.isAdmin){
      cloudSetMsg_("Admin only.", "warn");
      return;
    }
    const E = cloudEls_();
    const pk = String((E.shareKey && E.shareKey.value) ? E.shareKey.value : "").trim().toUpperCase();
    const csRaw = String((E.shareCallsigns && E.shareCallsigns.value) ? E.shareCallsigns.value : "").trim();
    if(!pk || !csRaw){
      cloudSetMsg_("Enter Share key + callsigns list.", "warn");
      return;
    }
    const list = csRaw.split(",").map(s=>String(s||"").trim().toUpperCase()).filter(Boolean);
    if(!list.length){
      cloudSetMsg_("No callsigns found.", "warn");
      return;
    }
    cloudSetMsg_("Setting share…");
    try{
      for(const cs of list){
        await tywApi_("budgetAccessSet", { callsign: cs, profileKey: pk, role: "RW" });
      }
      cloudSetMsg_("Share set: " + pk + " ← " + list.join(", "), "ok");
    }catch(e){
      cloudSetMsg_(String(e && e.message ? e.message : e), "bad");
    }
  }

  function cloudAdoptSlbSession_(forceLoad){
    const before = String(CLOUD.token || "");
    cloudReadSession_();
    cloudShowLogin_(false);
    cloudShowAdmin_(!!CLOUD.isAdmin);
    cloudEnableButtons_(!!CLOUD.token);

    if(!CLOUD.token){
      cloudSetStatus_("Waiting for SLB login…");
      cloudSetMsg_("Open BB Budget after SLB finishes signing you in.", "warn");
      return Promise.resolve(false);
    }

    const changed = before !== CLOUD.token || _embeddedSessionToken !== CLOUD.token;
    if(changed) CLOUD.loadedOnce = false;
    _embeddedSessionToken = CLOUD.token;
    cloudSetMsg_("Connected through SLB as " + (CLOUD.callsign || "disciple") + ".", "ok");
    if(!forceLoad && !changed && CLOUD.loadedOnce) return Promise.resolve(true);
    if(_embeddedLoadPromise) return _embeddedLoadPromise;
    _embeddedLoadPromise = Promise.resolve(cloudLoadFromCloud_()).then(()=>true).finally(()=>{ _embeddedLoadPromise = null; });
    return _embeddedLoadPromise;
  }

  function bindEmbeddedSlbSession_(){
    if(!isSlbEmbedded_() || TYBH.ui._slbSessionBridgeBound) return;
    TYBH.ui._slbSessionBridgeBound = true;
    const fallbackTimers = [];
    const clearFallbacks = ()=>{
      while(fallbackTimers.length){
        try{ clearTimeout(fallbackTimers.pop()); }catch(_e){}
      }
    };
    const adopt = ()=>{
      try{
        const out = cloudAdoptSlbSession_(false);
        if(CLOUD.token) clearFallbacks();
        return out;
      }catch(_e){}
    };
    try{ window.addEventListener("slb:auth-ready", adopt); }catch(_e){}
    try{ window.addEventListener("slb:dashboard-updated", adopt); }catch(_e){}
    try{ window.addEventListener("storage", (e)=>{ if(e && e.key === "slb_webapp_url") CLOUD.url = slbResolveWebappUrl_(); }); }catch(_e){}
    if(!CLOUD.token){
      [2500, 8000, 18000].forEach((delay)=>{
        fallbackTimers.push(setTimeout(adopt, delay));
      });
    }
  }

  function cloudInit(){
    CLOUD.url = slbResolveWebappUrl_();
    cloudSyncBackendUi_();
    cloudReadSession_();

    if(isSlbEmbedded_()){
      bindEmbeddedSlbSession_();
      cloudAdoptSlbSession_(true);
      return;
    }

    cloudEnableButtons_(!!CLOUD.token);
    cloudShowLogin_(!CLOUD.token);
    cloudShowAdmin_(!!CLOUD.isAdmin);

    // Prefill login callsign if known
    try{
      const E = cloudEls_();
      if(E.callsign && !E.callsign.value && CLOUD.callsign) E.callsign.value = CLOUD.callsign;
    }catch(_e){}

    // Auto-login from SLB saved login (optional), then auto-load
    if(!CLOUD.token){
      Promise.resolve(cloudAutoLoginFromSLB_()).finally(()=>{ cloudLoadFromCloud_(); });
    }else{
      cloudLoadFromCloud_();
    }
  }

  // Expose for inline HTML buttons
  TYBH.ui.cloudInit = cloudInit;
  TYBH.ui.cloudLogin = cloudLogin;
  TYBH.ui.cloudLogout = cloudLogout;
  TYBH.ui.cloudSetBackend = cloudSetBackend;
  TYBH.ui.cloudPing = cloudPing;
  TYBH.ui.cloudSaveNow = cloudSaveNow;
  TYBH.ui.cloudReload = cloudReload;
  TYBH.ui.cloudViewAs = cloudViewAs;
  TYBH.ui.cloudSetShare = cloudSetShare;
  TYBH.ui.cloudCreateTab = cloudCreateTab;
  TYBH.ui.cloudDiag = cloudDiag;
  TYBH.ui.cloudWipeProfile = cloudWipeProfile;
  TYBH.ui.cloudReplaceCloud = cloudReplaceCloud;
  TYBH.ui.openEmbedded = function(){
    try{ init(); }catch(_e){}
    if(!isSlbEmbedded_()) return Promise.resolve(false);
    return cloudAdoptSlbSession_(false);
  };
  TYBH.ui.refreshFromSlbSession = function(){ return cloudAdoptSlbSession_(true); };


  // Import preflight
  let _pendingImportText = null;
  let _pendingImportFileName = "";

  // util locals
  const {
    escapeHtml, escapeAttr,
    isoToday, ymToday, toMonth,
    num, money, uid,
    monthLabel, uniq
  } = U;

  function preprocessCsvText(text){
    let t = String(text || "");
    // strip UTF-8 BOM
    if(t && t.charCodeAt(0) === 0xFEFF) t = t.slice(1);
    // Excel sometimes adds "sep=," on first line
    t = t.replace(/^sep=.*,\r?\n/i, "");
    // normalize line endings
    t = t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    // trim trailing spaces on lines (doesn't touch commas)
    t = t.split("\n").map((line)=>line.replace(/[ \t]+$/g,"")).join("\n");
    return t;
  }



  // core locals
  const {
    allMonths,
    loadFromMaster,
    monthTx,
    sumTxWhere,
    spentFor,
    evalWarningsForTx,
    applyFlagsForTx,
    computedBalanceFor,
    reconcileLedger,
    mergeAccountsByName,
    billsDueNext7Days,
    downloadMaster: downloadMasterCore,
    downloadTxOnly: downloadTxOnlyCore,
    buildGptPack: buildGptPackCore,
    loadDemo: loadDemoCore
  } = C;

  // state/constants
  const state = TYBH.state;
  const DEFAULT_HEADER_TX = TYBH.DEFAULT_HEADER_TX;

  if (!state || !DEFAULT_HEADER_TX) {
    console.error(
      "Budget Hub: state/DEFAULT_HEADER_TX missing. Did core export them? (TYBH.state, TYBH.DEFAULT_HEADER_TX)"
    );
    return;
  }


  const DEMO_CSV_URL = "https://cdn.shopify.com/s/files/1/1299/3411/files/bb_budget_sample_tin_meow_tin_crab_3mo.csv?v=1766569736";


  
  /* ============================
     v5: session meta + autosave snapshot (local only)
  ============================ */
  const LS_KEY = "TYBH_AUTOSAVE_V1";
  const META = state._meta = state._meta || { fileName: "", dirty: false, lastExportTs: 0 };

  function fmtDT(ts){
    if(!ts) return "—";
    try{
      const d = new Date(ts);
      return d.toLocaleString();
    }catch(e){ return "—"; }
  }

  function updateStatusStrip(){
    const fileEl = $("stFile");
    const rowsEl = $("stRows");
    const savedEl = $("stSaved");
    const dirtyEl = $("stDirty");
    if(fileEl) fileEl.textContent = META.fileName || (state._isDemo ? "DEMO" : "—");
    if(rowsEl) rowsEl.textContent = String((state.tx && state.tx.length) ? state.tx.length : 0);
    if(savedEl) savedEl.textContent = fmtDT(META.lastExportTs);
    if(dirtyEl) dirtyEl.classList.toggle("hidden", !META.dirty);
  }

  let _snapTimer = null;
  function scheduleSnapshot(){
    if(_snapTimer) clearTimeout(_snapTimer);
    _snapTimer = setTimeout(saveSnapshotNow, 1200);
  }

  function safeSnapshotPayload(){
    // keep only the essential parts of state (serializable)
    return {
      v: 6,
      ts: Date.now(),
      meta: {
        fileName: META.fileName || "",
        dirty: !!META.dirty,
        lastExportTs: META.lastExportTs || 0
      },
      data: {
        settings: state.settings || {},
        rules: state.rules || {},
        accounts: state.accounts || [],
        bills: state.bills || [],
        budgets: state.budgets || [],
        goals: state.goals || [],
        categories: state.categories || [],
        grow: state.grow || {},
        move: state.move || {},
        tx: state.tx || []
      }
    };
  }

  function saveSnapshotNow(){
    try{
      const payload = safeSnapshotPayload();
      const json = JSON.stringify(payload);
      // localStorage practical limit ~5MB; keep a buffer
      if(json.length > 4_500_000) return;
      localStorage.setItem(LS_KEY, json);
    }catch(e){
      // ignore storage errors (private mode, quota, etc.)
    }
  }

  function loadSnapshot(){
    try{
      const raw = localStorage.getItem(LS_KEY);
      if(!raw) return null;
      const obj = JSON.parse(raw);
      if(!obj || !obj.data || !obj.ts) return null;
      return obj;
    }catch(e){ return null; }
  }

  function showRestoreBannerIfNeeded(){
    // Only prompt if nothing loaded yet (first open), and snapshot exists
    if(state.loaded) return false;
    const snap = loadSnapshot();
    if(!snap) return false;
    state._restoreOffered = true;
    const el = $("restoreBanner");
    const when = $("restoreWhen");
    if(when) when.textContent = fmtDT(snap.ts);
    if(el) el.classList.remove("hidden");
    return true;
  }

  function dismissRestore(){
    state._restoreOffered = false;
    const el = $("restoreBanner");
    if(el) el.classList.add("hidden");
    // If nothing is loaded yet, fall back to demo so page isn't empty
    if(!state.loaded){
      try{ loadDemoFromUrl(DEMO_CSV_URL, false); }catch(e){}
    }
  }

  function restoreLastSession(){
    const snap = loadSnapshot();
    if(!snap || !snap.data) return dismissRestore();
    try{
      // restore state fields
      state.settings = snap.data.settings || {};
      state.rules = snap.data.rules || {};
      state.accounts = snap.data.accounts || [];
      state.bills = snap.data.bills || [];
      state.budgets = snap.data.budgets || [];
      state.goals = snap.data.goals || [];
      state.categories = snap.data.categories || [];
      state.grow = snap.data.grow || {};
      state.move = snap.data.move || {};
      state.tx = snap.data.tx || [];
      state.loaded = true;
      state._isDemo = false;

      META.fileName = (snap.meta && snap.meta.fileName) ? snap.meta.fileName : (META.fileName || "");
      META.dirty = true; // restored work should be treated as unsaved until exported
      META.lastExportTs = (snap.meta && snap.meta.lastExportTs) ? snap.meta.lastExportTs : 0;

      state._restoreOffered = false;
      dismissRestore();
      if($("stStatus")) $("stStatus").textContent = "Loaded (restored)";
      setDemoMode(false);
      afterLoad();
      updateStatusStrip();
      // go to overview for quick visibility
      try{ showTab("overview"); }catch(e){}
    }catch(e){
      console.error(e);
      dismissRestore();
    }
  }

  function markDirty(on=true){
    META.dirty = !!on;
    updateStatusStrip();
    if(META.dirty){
      scheduleSnapshot();
      try{ scheduleCloudSave_(); }catch(_e){}
    }
  }

  function markExported(){
    META.lastExportTs = Date.now();
    META.dirty = false;
    updateStatusStrip();
    saveSnapshotNow();
  }

  function setLoadedFileName(name){
    META.fileName = (name || "").trim();
    updateStatusStrip();
    saveSnapshotNow();
  }

/* ============================
     Small helpers
  ============================ */
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);
  const onDelegate = (el, ev, selector, fn) => {
    if (!el) return;
    el.addEventListener(ev, (e) => {
      const t = e.target && e.target.closest ? e.target.closest(selector) : null;
      if (!t || !el.contains(t)) return;
      fn(e, t);
    });
  };

  /* ============================
     Toast notifications (1.9a)
     - non-blocking feedback for newbies
  ============================ */
  function toast(msg, kind="ok", sub=""){
    try{
      const host = $("tyToastHost");
      if(!host) return;
      const t = document.createElement("div");
      t.className = "tyToast " + (kind || "ok");
      const icon = (kind === "err") ? "!" : (kind === "warn") ? "⚠" : "✓";
      t.innerHTML = `
        <div class="tIcon">${escapeHtml(icon)}</div>
        <div class="tBody">
          <div class="tMsg">${escapeHtml(String(msg||""))}</div>
          ${sub ? `<div class="tSub">${escapeHtml(String(sub||""))}</div>` : ""}
        </div>
      `;
      host.appendChild(t);
      // auto remove
      const ttl = (kind === "err") ? 5200 : (kind === "warn") ? 4200 : 3200;
      setTimeout(() => { try{ t.remove(); }catch(_){ } }, ttl);
    }catch(_){
      // ignore
    }
  }
  TYBH.ui.toast = toast;

  /* ============================
     Undo stack (v2.0)
     - simple, safe, last-action undo
  ============================ */
  const UNDO_MAX = 20;
  const UNDO = TYBH.ui._undo = TYBH.ui._undo || { stack: [] };

  function cloneDataForUndo(){
    // keep it small + serializable
    return {
      settings: state.settings || {},
      rules: state.rules || {},
      accounts: state.accounts || [],
      bills: state.bills || [],
      budgets: state.budgets || [],
      goals: state.goals || [],
      categories: state.categories || [],
      grow: state.grow || {},
      move: state.move || {},
      tx: state.tx || []
    };
  }

  function pushUndo(label){
    try{
      const entry = {
        ts: Date.now(),
        label: String(label||"Change"),
        data: JSON.parse(JSON.stringify(cloneDataForUndo()))
      };
      UNDO.stack.unshift(entry);
      if(UNDO.stack.length > UNDO_MAX) UNDO.stack.length = UNDO_MAX;
      syncUndoBtn();
    }catch(e){
      // ignore
    }
  }

  function applyUndoPayload(payload){
    if(!payload) return;
    state.settings = payload.settings || state.settings || {};
    state.rules = payload.rules || state.rules || {};
    state.accounts = payload.accounts || [];
    state.bills = payload.bills || [];
    state.budgets = payload.budgets || [];
    state.goals = payload.goals || [];
    state.categories = payload.categories || [];
    state.grow = payload.grow || state.grow || {};
    state.move = payload.move || state.move || {};
    state.tx = payload.tx || [];
  }

  function canUndo(){ return !!(UNDO.stack && UNDO.stack.length); }

  function syncUndoBtn(){
    const b = $("undoBtn");
    if(!b) return;
    b.classList.toggle("hidden", !canUndo());
    if(canUndo()){
      const top = UNDO.stack[0];
      b.title = `Undo: ${top.label}`;
    }
  }

  function undoLast(){
    if(!canUndo()) return;
    const top = UNDO.stack.shift();
    applyUndoPayload(top.data);
    markDirty(true);
    try{ rebuildDropdowns(); }catch(_){ }
    try{ afterLoad(); }catch(_){ }
    toast("Undone", "ok", top.label);
    syncUndoBtn();
  }

  // expose for onclick if needed
  TYBH.ui.pushUndo = pushUndo;
  TYBH.ui.undoLast = undoLast;

  /* ============================
     UI helpers (month selectors)
  ============================ */
  function fillMonthSelect(sel, currentValue) {
    if (!sel) return;
    const months = typeof allMonths === "function" ? allMonths() : [];
    const keep = (currentValue !== undefined ? currentValue : sel.value) || "";
    sel.innerHTML =
      `<option value="">All</option>` +
      months
        .map(
          (m) =>
            `<option value="${escapeAttr(m)}">${escapeHtml(
              monthLabel(m)
            )}</option>`
        )
        .join("");
    sel.value = keep;
    if (sel.value === "" && keep !== "") sel.value = "";
  }

  function refreshMonthSelectors() {
    fillMonthSelect($("monthPick"));
    fillMonthSelect($("txMonth"));
    fillMonthSelect($("gptMonth"));
    fillMonthSelect($("todayMonth"));
    fillMonthSelect($("budMonth"));
    fillMonthSelect($("moveMonth"));
  }

  /* ============================
     Init (safe to call multiple times)
  ============================ */
  function init() {
    const root = document.getElementById("tyBudgetHub");
    if (!root) return;
    if (TYBH.ui._initDone) return;
    TYBH.ui._initDone = true;

    // Hide BaseStation "Enter special code" unlock UI on BB Budget pages
    try{
      var locked = document.getElementById("tyCodeCardLocked");
      if(locked) locked.style.display = "none";
      var codeInp = document.getElementById("tyAdminCode");
      if(codeInp && codeInp.closest) {
        var card = codeInp.closest(".tyCodeCard");
        if(card) card.style.display = "none";
      }
    }catch(_e){}

    // grouped menu dropdowns
    showRestoreBannerIfNeeded();
    setupNavBar();
    try{ localStorage.setItem("tybh_lastTab","overview"); }catch(_e){}
    routeToTab("overview");
    updateStatusStrip();

    // Cloud (optional)
    try{ cloudInit(); }catch(_e){}

    try{ initTopPolish_(); }catch(_e){}


    // undo button
    if ($("undoBtn")) $("undoBtn").onclick = () => undoLast();
    syncUndoBtn();

    initQuickStart();
    initHelpAndWizard();
    initCategoriesTab();
    initTaxTab();


    if ($("setCurrency")) $("setCurrency").value = state.settings.currency || "USD";
    if ($("setPeople")) $("setPeople").value = (state.settings.people || []).join(", ");
    // auto-load demo CSV on first open (only if nothing loaded yet)
    if (!state.loaded && !state._restoreOffered) loadDemoFromUrl(DEMO_CSV_URL, false);

    // Import file handler (with preflight)
function hidePreflight(){
  _pendingImportText = null;
  _pendingImportFileName = "";
  if($("importPreflight")) $("importPreflight").style.display = "none";
}

function showPreflight(summary){
  if(!$("importPreflight")) return;
  $("importPreflight").style.display = "block";
  if($("pfFileName")) $("pfFileName").textContent = _pendingImportFileName || "";
  if($("pfType")) $("pfType").textContent = summary.isMaster ? "MASTER CSV" : "TRANSACTIONS CSV";
  if($("pfTxCount")) $("pfTxCount").textContent = String(summary.counts?.tx ?? 0);
  if($("pfTxDup")) $("pfTxDup").textContent = String(summary.txDup ?? 0);

  const dup = Number(summary.txDup||0);
  const hint = dup>0 ? (`${dup} duplicates found. If you enable removal, import will keep ${summary.txDedupIfEnabled} unique transactions.`)
                     : "No duplicates detected.";
  if($("pfDedupHint")) $("pfDedupHint").textContent = hint;
}

function commitPreflightImport(){
  if(!_pendingImportText) return;
  try{
    const dedup = !!($("pfDedup") && $("pfDedup").checked);
    setDemoMode(false);
    loadFromMaster(_pendingImportText, {dedup});
    afterLoad();
    markDirty(false);
    saveSnapshotNow();
    if($("importMsg")){
      $("importMsg").innerHTML = `<span class="ok">Imported:</span> ${escapeHtml(_pendingImportFileName || "CSV")} ${dedup ? "(duplicates removed if any)" : ""}`;
    }
    hidePreflight();
    // clear file input so user can re-import same file if needed
    if($("fileInput")) $("fileInput").value = "";
  }catch(err){
    console.error(err);
    state.loaded = false;
    if ($("stStatus")) $("stStatus").textContent = "Not loaded";
    if ($("importMsg")) {
      $("importMsg").innerHTML = `<span class="err">Import failed:</span> ${escapeHtml(err?.message || String(err))}`;
    }
    showTab("import");
    alert("Import failed. Open Console for details.");
  }
}

if($("pfCancelBtn")) on($("pfCancelBtn"), "click", hidePreflight);
if($("pfCommitBtn")) on($("pfCommitBtn"), "click", commitPreflightImport);

if ($("fileInput")) {
  $("fileInput").addEventListener("change", (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const txt = preprocessCsvText(String(reader.result || ""));
        _pendingImportText = txt;
        _pendingImportFileName = f && f.name ? f.name : "import.csv";
        setLoadedFileName(_pendingImportFileName);

        // Preflight summary
        if(!C.preflightImport){
          // fallback: import directly (older core)
          loadFromMaster(txt);
          afterLoad();
          markDirty(false);
          saveSnapshotNow();
          if($("importMsg")) $("importMsg").innerHTML = `<span class="ok">Imported:</span> ${escapeHtml(_pendingImportFileName)}`;
          return;
        }
        const summary = C.preflightImport(txt);
        showPreflight(summary);
        if($("importMsg")) $("importMsg").innerHTML = `<span class="ok">File ready.</span> Review preflight and click “Import Now”.`;
      } catch (err) {
        console.error(err);
        hidePreflight();
        state.loaded = false;
        if ($("stStatus")) $("stStatus").textContent = "Not loaded";
        if ($("importMsg")) {
          $("importMsg").innerHTML = `<span class="err">Import failed:</span> ${escapeHtml(
            err && err.message ? err.message : String(err)
          )}`;
        }
        showTab("import");
        alert("Import failed. Open Console for details.");
      }
    };
    reader.onerror = () => {
      hidePreflight();
      if ($("importMsg"))
        $("importMsg").innerHTML = `<span class="err">Could not read file.</span>`;
    };
    reader.readAsText(f);
  });
}

    // TX delegated click handler (edit + sort)
    onDelegate($("txRows"), "click", '[data-action="edit"]', (e, a) => {
      openEditById(a.dataset.id);
    });
    onDelegate($("txRows"), "click", "th[data-sort]", (e, th) => {
      const key = th.dataset.sort;
      if (!key) return;
      if (txSort.key === key) {
        txSort.dir = txSort.dir === "asc" ? "desc" : "asc";
      } else {
        txSort.key = key;
        txSort.dir = key === "Amount" ? "desc" : "asc";
        if (key === "Date") txSort.dir = "desc";
      }
      renderTx();
    });

    // TX filter auto-refresh
    on($("txQ"), "input", renderTx);
    ["txType", "txAccount", "txImpulse", "txMissingAcc"].forEach((id) => {
      on($(id), "change", renderTx);
    });

    // Accounts events (delegated)
    if ($("accRows")) {
      $("accRows").addEventListener("input", (e) => {
        const el = e.target;
        if (!(el && el.dataset && el.dataset.accIdx)) return;

        const idx = Number(el.dataset.accIdx);
        const field = el.dataset.accField;
        const a = state.accounts[idx];
        if (!a) return;

        if (field === "StartBalance") {
          a.StartBalance = num(el.value);
          updateAccountRow(idx);
          return;
        }
        if (field === "BankBalance") {
          a.BankBalance = String(el.value || "").trim() === "" ? "" : num(el.value);
          updateAccountRow(idx);
          return;
        }
        if (field === "Owner") { a.Owner = String(el.value || ""); return; }
        if (field === "Type") { a.Type = String(el.value || ""); return; }
        if (field === "Active") { a.Active = String(el.value || "Y"); return; }
      });

      $("accRows").addEventListener("change", (e) => {
        const el = e.target;
        if (!(el && el.dataset && el.dataset.accIdx)) return;
        const idx = Number(el.dataset.accIdx);
        const field = el.dataset.accField;
        const a = state.accounts[idx];
        if (!a) return;

        if (field === "Nature") {
          a.Nature = String(el.value || "ASSET").toUpperCase() === "LIABILITY" ? "LIABILITY" : "ASSET";
          updateAccountRow(idx);
        }
        if (field === "Active") {
          a.Active = String(el.value || "Y");
        }
      });

      $("accRows").addEventListener("click", (e) => {
        const btn = e.target.closest('button[data-action="remove-acc"]');
        if (!btn) return;
        const idx = Number(btn.dataset.accIdx);
        if (!isFinite(idx)) return;
        if (!confirm("Remove this account from settings? (Transactions stay)")) return;
        state.accounts.splice(idx, 1);
        mergeAccountsByName();
        rebuildDropdowns();
        renderAccounts();
      });
    }

    // Budgets events
    if ($("budTable")) {
      $("budTable").addEventListener("input", (e) => {
        const row = e.target.closest("tr[data-bud-i]");
        if (!row) return;
        const i = Number(row.dataset.budI);
        const b = state.budgets[i];
        if (!b) return;

        const field = e.target.dataset.budField;
        if (!field) return;

        if (field === "BudgetAmount") b.BudgetAmount = num(e.target.value);
        else if (field === "Active") b.Active = e.target.value;
        else b[field] = String(e.target.value || "");

        refreshToday();
      });

      $("budTable").addEventListener("change", (e) => {
        const row = e.target.closest("tr[data-bud-i]");
        if (!row) return;
        const i = Number(row.dataset.budI);
        const b = state.budgets[i];
        if (!b) return;
        const field = e.target.dataset.budField;
        if (field === "Active") {
          b.Active = e.target.value;
          refreshToday();
        }
      });

      $("budTable").addEventListener("click", (e) => {
        const btn = e.target.closest('button[data-action="del-bud"]');
        if (!btn) return;
        if (!confirm("Remove this budget row?")) return;

        const i = Number(btn.dataset.budI);
        if (isFinite(i) && i >= 0) state.budgets.splice(i, 1);

        renderBudgets();
        refreshToday();
      });
    }

    on($("budMonth"), "change", renderBudgets);
    on($("budType"), "change", renderBudgets);

    // Bills events
    if ($("billTable")) {
      $("billTable").addEventListener("input", (e) => {
        const tr = e.target.closest("tr[data-bill-idx]");
        if (!tr) return;
        const idx = Number(tr.dataset.billIdx);
        const b = state.bills[idx];
        if (!b) return;

        const field = e.target.dataset.billField;
        if (!field) return;

        if (field === "Amount") b.Amount = num(e.target.value);
        else if (field === "DueDay") b.DueDay = Math.max(1, Math.min(31, num(e.target.value)));
        else b[field] = String(e.target.value || "");

        refreshToday();
      });

      $("billTable").addEventListener("change", (e) => {
        const tr = e.target.closest("tr[data-bill-idx]");
        if (!tr) return;
        const idx = Number(tr.dataset.billIdx);
        const b = state.bills[idx];
        if (!b) return;

        const field = e.target.dataset.billField;
        if (!field) return;

        if (field === "AutoPay" || field === "Active" || field === "Account") {
          b[field] = String(e.target.value || "");
          refreshToday();
        }
      });

      $("billTable").addEventListener("click", (e) => {
        const btn = e.target.closest('button[data-action="del-bill"]');
        if (!btn) return;
        const idx = Number(btn.dataset.billIdx);
        if (!isFinite(idx)) return;
        if (!confirm("Remove this bill?")) return;
        state.bills.splice(idx, 1);
        renderBills();
      });
    }

    // Move events
    if ($("moveTable")) {
      $("moveTable").addEventListener("input", (e) => {
        const tr = e.target.closest("tr[data-move-idx]");
        if (!tr) return;
        const idx = Number(tr.dataset.moveIdx);
        const it = state.move[idx];
        if (!it) return;

        const field = e.target.dataset.moveField;
        if (!field) return;

        if (field === "Amount") it.Amount = num(e.target.value);
        else it[field] = String(e.target.value || "");

        renderMove();
      });

      $("moveTable").addEventListener("change", (e) => {
        const tr = e.target.closest("tr[data-move-idx]");
        if (!tr) return;
        const idx = Number(tr.dataset.moveIdx);
        const it = state.move[idx];
        if (!it) return;

        const field = e.target.dataset.moveField;
        if (!field) return;

        if (field === "Kind" || field === "Active") {
          it[field] = String(e.target.value || "");
          renderMove();
        }
      });

      $("moveTable").addEventListener("click", (e) => {
        const btn = e.target.closest('button[data-action="del-move"]');
        if (!btn) return;
        const idx = Number(btn.dataset.moveIdx);
        if (!isFinite(idx)) return;
        if (!confirm("Remove this move item?")) return;
        state.move.splice(idx, 1);
        renderMove();
      });
    }

    on($("moveMonth"), "change", renderMove);

    // Today month/focus
    on($("todayMonth"), "change", refreshToday);
    on($("todayFocusCat"), "change", refreshToday);

    // Bulk watchers
    ["bkCatType", "bkOldCat", "bkSubType", "bkSubCat", "bkOldSub", "bkOldAcc", "bkOldPerson"].forEach((id) => {
      on($(id), "change", () => rebuildBulkUI(id === "bkCatType" || id === "bkSubType"));
    });

    // Goals events (delegation) — DO NOT re-render editor on input (prevents bounce)
    if ($("goalsEditor")) {
      $("goalsEditor").addEventListener("input", (e) => {
        const tr = e.target.closest("tr[data-goal-idx]");
        if (!tr) return;
        const idx = Number(tr.dataset.goalIdx);
        const g = state.goals[idx];
        if (!g) return;
        const field = e.target.dataset.goalField;
        if (!field) return;

        if (field === "TargetAmount" || field === "CurrentAmount") {
          g[field] = num(e.target.value);
        } else {
          g[field] = String(e.target.value || "");
        }

        renderGoalsSummary(); // safe (different DOM area)
      });

      $("goalsEditor").addEventListener("change", (e) => {
        const tr = e.target.closest("tr[data-goal-idx]");
        if (!tr) return;
        const idx = Number(tr.dataset.goalIdx);
        const g = state.goals[idx];
        if (!g) return;
        const field = e.target.dataset.goalField;
        if (field === "Active") {
          g.Active = String(e.target.value || "Y");
          renderGoalsEditor();
          renderGoalsSummary();
        }
      });

      $("goalsEditor").addEventListener("click", (e) => {
        const btn = e.target.closest('button[data-action="del-goal"]');
        if (!btn) return;
        const idx = Number(btn.dataset.goalIdx);
        if (!isFinite(idx)) return;
        if (!confirm("Remove this goal?")) return;
        state.goals.splice(idx, 1);
        renderGoalsEditor();
        renderGoalsSummary();
      });
    }

    // MonthPick -> overview refresh
    on($("monthPick"), "change", renderOverview);
    on($("txMonth"), "change", renderTx);

    // If core already loaded data before init ran, render now
    if (state.loaded) {
      renderAll();
      try {
        const last = localStorage.getItem("tybh_lastTab") || "";
        if (last && last !== "import") {
          routeToTab(last);
        } else if (!state._isDemo && state.tx && state.tx.length) {
          // Cleaner start: do not strand people on Import after data is already loaded
          routeToTab("overview");
        }
      } catch (e) {
        routeToTab("today");
      }
    }
  }

  /* ============================
     afterLoad (UI hook)
  ============================ */
  function afterLoad() {
    // Ensure DOM + init are ready (core might call afterLoad early)
    if (document.readyState === "loading" || !document.getElementById("tyBudgetHub")) {
      document.addEventListener("DOMContentLoaded", afterLoad, { once: true });
      return;
    }
    init();

    state.loaded = true;

    if ($("stStatus")) $("stStatus").textContent = state._isDemo ? "Loaded (DEMO)" : "Loaded";
    if ($("importMsg")){
      const demoNote = state._isDemo ? ' <span class="warn">DEMO CSV LOADED</span>' : '';
      $("importMsg").innerHTML = `<span class="ok">Loaded.</span> Transactions: <b>${state.tx.length}</b>${demoNote}`;
    }

    if ($("setCurrency")) $("setCurrency").value = state.settings.currency || "USD";
    if ($("setPeople")) $("setPeople").value = (state.settings.people || []).join(", ");

    // bootstrap accounts if missing
    if (!state.accounts.length) {
      const accSet = new Set((state.tx || []).map((t) => t.Account).filter(Boolean));
      state.accounts = Array.from(accSet)
        .sort()
        .map((a) => ({
          Account: a,
          Owner: "",
          Type: "",
          Nature: "ASSET",
          StartBalance: 0,
          BankBalance: "",
          Active: "Y"
        }));
    }

    if ($("exDate")) $("exDate").value = isoToday();
    if ($("inDate")) $("inDate").value = isoToday();

    mergeAccountsByName();
    rebuildDropdowns();
    refreshMonthSelectors();

    // default months
    const cur = ymToday();
    ["monthPick", "txMonth", "gptMonth", "todayMonth", "budMonth", "moveMonth"].forEach((id) => {
      const el = $(id);
      if (el) el.value = cur;
    });

    loadRulesUI();
    renderAll();

    try{ autoCleanTopAfterLoad_(); }catch(_e){}


    updateDemoUI();

    // restore last tab
    try {
      const last = localStorage.getItem("tybh_lastTab") || "";
      if (last && last !== "import") routeToTab(last);
    } catch (e) {}
  }

  // Make it visible for both modular + legacy calls
  window.afterLoad = afterLoad;
  TYBH.ui.afterLoad = afterLoad;

  /* ============================
     Dropdown builders
  ============================ */
  function fillSelect(sel, items) {
    if (!sel) return;
    sel.innerHTML = (items || [])
      .map((x) => `<option value="${escapeAttr(x)}">${escapeHtml(x)}</option>`)
      .join("");
  }
  function fillSelectWithBlank(sel, items, blank = "(choose)") {
    if (!sel) return;
    sel.innerHTML =
      `<option value="">${escapeHtml(blank)}</option>` +
      (items || [])
        .map((x) => `<option value="${escapeAttr(x)}">${escapeHtml(x)}</option>`)
        .join("");
  }

  
  
  // Special option value for inline "Add new…" in dropdowns
  const TYBH_ADD_NEW_VALUE = "__ADD_NEW__";

  function ensureAddNewOption(sel, label="+ Add new…"){
    if(!sel) return;
    // avoid duplicates
    const has = Array.from(sel.options||[]).some(o => o && o.value === TYBH_ADD_NEW_VALUE);
    if(has) return;
    const opt = document.createElement("option");
    opt.value = TYBH_ADD_NEW_VALUE;
    opt.textContent = label;
    sel.appendChild(opt);
  }

  function bindAddNewDropdown(sel, kind, type, prefix){
    if(!sel) return;
    if(sel.dataset && sel.dataset.tybhAddNewBound==="1") return;
    if(sel.dataset) sel.dataset.tybhAddNewBound="1";

    sel.addEventListener("change", () => {
      if(sel.value !== TYBH_ADD_NEW_VALUE) return;

      // revert quickly so UI doesn't get stuck on the sentinel
      const prev = sel.dataset ? (sel.dataset.tybhPrevValue || "") : "";
      // run add flow
      if(kind === "cat"){
        const added = quickAddCategory(type, prefix);
        if(added){
          sel.value = added;
          if(sel.dataset) sel.dataset.tybhPrevValue = added;
          rebuildSub(prefix);
          return;
        }
        // cancelled
        sel.value = prev || "";
        return;
      }

      if(kind === "sub"){
        const added = quickAddSubcategory(type, prefix);
        if(added){
          sel.value = added;
          if(sel.dataset) sel.dataset.tybhPrevValue = added;
          return;
        }
        sel.value = prev || "";
      }
    });

    // track previous value
    sel.addEventListener("focus", () => {
      if(sel.dataset) sel.dataset.tybhPrevValue = String(sel.value||"");
    });
  }
function rebuildSub(prefix) {
    const catSel = $(prefix + "Category");
    const subSel = $(prefix + "Subcategory");
    if (!catSel || !subSel) return;

    const cat = String(catSel.value || "").trim();
    const wantType = (prefix === "ex" ? "Expense" : "Income");

    const subs = uniq(
      (state.categories || [])
        .filter(c => String(c.Active || "Y").toUpperCase() !== "N")
        .filter(c => (String(c.Type || wantType)).toLowerCase().startsWith(wantType.toLowerCase().slice(0,3)))
        .filter(c => String(c.Category || "").trim() === cat)
        .map(c => c.Subcategory)
        .concat(
          (state.tx || [])
            .filter(t => String(t.Type || "Expense") === wantType && String(t.Category || "").trim() === cat)
            .map(t => t.Subcategory)
        )
    ).map(s => String(s || "").trim()).filter(Boolean).sort();

    if (!subs.length) subs.push("General");

    fillSelectWithBlank(subSel, subs, "(none)");

    ensureAddNewOption(subSel);
    bindAddNewDropdown(subSel, "sub", (prefix==="ex"?"Expense":"Income"), prefix);
}



  function applyTemplateFromHistory() {
    const codeEl = $("exTemplate");
    if (!codeEl) return;
    const code = codeEl.value;
    if (!code) return;

    const found = [...(state.tx || [])].reverse().find((t) => t.Item === code && t.Type === "Expense");
    if (!found) return;

    if (found.Account && $("exAccount")) $("exAccount").value = found.Account;
    if (found.Category && $("exCategory")) $("exCategory").value = found.Category;
    rebuildSub("ex");
    if (found.Subcategory && $("exSubcategory")) $("exSubcategory").value = found.Subcategory;

    if ($("exPayee")) $("exPayee").value = found.Payee || $("exPayee").value;
    if ($("exAmount")) $("exAmount").value = found.Amount || $("exAmount").value;
  }

  function rebuildDropdowns() {
    // people: from settings + tx persons (filter empty)
    let people = uniq((state.settings.people || []).concat((state.tx || []).map((t) => t.Person)))
      .map((x) => String(x || "").trim())
      .filter(Boolean);

    if (!people.length) people = ["Tin Lei", "Tin Wing"];
    state.settings.people = people;

    const accounts = uniq((state.accounts || []).map((a) => a.Account).concat((state.tx || []).map((t) => t.Account)))
      .map((x) => String(x || "").trim())
      .filter(Boolean)
      .sort();

    const catRows = (state.categories || []).filter(c => String(c.Active||"Y").toUpperCase()!=="N");
    const catsExp = uniq(
      catRows.filter(c => String(c.Type||"Expense").toLowerCase().startsWith("exp")).map(c=>c.Category)
      .concat((state.budgets||[]).filter(b=>String(b.Type||"Expense").toLowerCase().startsWith("exp")).map(b=>b.Category))
      .concat((state.tx || []).filter((t) => t.Type === "Expense").map((t) => t.Category))
    ).map(s=>String(s||"").trim()).filter(Boolean).sort();

    const catsInc = uniq(
      catRows.filter(c => String(c.Type||"Income").toLowerCase().startsWith("inc")).map(c=>c.Category)
      .concat((state.budgets||[]).filter(b=>String(b.Type||"Expense").toLowerCase().startsWith("inc")).map(b=>b.Category))
      .concat((state.tx || []).filter((t) => t.Type === "Income").map((t) => t.Category))
    ).map(s=>String(s||"").trim()).filter(Boolean).sort();

    if (!catsExp.length)
      catsExp.push(
        "Grocery",
        "Eat Out",
        "Cats",
        "Utility",
        "Transportation",
        "Subscriptions",
        "Fun",
        "Move Fund",
        "Investing Deposit",
        "Other"
      );
    if (!catsInc.length) catsInc.push("Income");

    const payees = uniq((state.tx || []).map((t) => t.Payee)).slice(0, 400);
    if ($("payeeList"))
      $("payeeList").innerHTML = payees.map((p) => `<option value="${escapeAttr(p)}"></option>`).join("");

    fillSelect($("exPerson"), people);
    fillSelect($("inPerson"), people);

    fillSelectWithBlank($("exAccount"), accounts, "(unassigned)");
    fillSelectWithBlank($("inAccount"), accounts, "(unassigned)");

    fillSelect($("exCategory"), catsExp);
    fillSelect($("inCategory"), catsInc);

    // inline "Add new…" inside dropdowns (newbie-friendly)
    ensureAddNewOption($("exCategory"));
    ensureAddNewOption($("inCategory"));
    bindAddNewDropdown($("exCategory"), "cat", "Expense", "ex");
    bindAddNewDropdown($("inCategory"), "cat", "Income", "in");

    // quick add category/subcategory
    if ($("exAddCatBtn")) $("exAddCatBtn").onclick = () => quickAddCategory("Expense", "ex");
    if ($("exAddSubBtn")) $("exAddSubBtn").onclick = () => quickAddSubcategory("Expense", "ex");
    if ($("inAddCatBtn")) $("inAddCatBtn").onclick = () => quickAddCategory("Income", "in");
    if ($("inAddSubBtn")) $("inAddSubBtn").onclick = () => quickAddSubcategory("Income", "in");

    if ($("exCategory")) $("exCategory").onchange = () => rebuildSub("ex");
    if ($("inCategory")) $("inCategory").onchange = () => rebuildSub("in");
    rebuildSub("ex");
    rebuildSub("in");

    const itemCodes = uniq((state.tx || []).map((t) => t.Item)).sort();
    const templ = [{ code: "", label: "(none)" }].concat(itemCodes.map((c) => ({ code: c, label: c })));
    if ($("exTemplate")) {
      $("exTemplate").innerHTML = templ
        .map((t) => `<option value="${escapeAttr(t.code)}">${escapeHtml(t.label)}</option>`)
        .join("");
      $("exTemplate").onchange = applyTemplateFromHistory;
    }

    fillSelectWithBlank($("txAccount"), accounts, "All");
    fillSelectWithBlank($("todayFocusCat"), catsExp, "(none)");

    refreshMonthSelectors();
    rebuildBulkUI(true);
  }

  // Alias used by quick-add category/subcategory flows
  function refreshTodaySelectors(){
    rebuildDropdowns();
  }



  
  /* ============================
     Category quick-add helpers
  ============================ */
  function ensureCategory(type, category){
    type = (type==="Income" ? "Income" : "Expense");
    category = String(category||"").trim();
    if(!category) return false;

    const exists = (state.categories||[]).some(c =>
      String(c.Active||"Y").toUpperCase()!=="N" &&
      String(c.Type||"Expense").toLowerCase().startsWith(type.toLowerCase().slice(0,3)) &&
      String(c.Category||"").trim().toLowerCase() === category.toLowerCase() &&
      String(c.Subcategory||"").trim() === ""
    );
    if(exists) return true;

    state.categories = state.categories || [];
    state.categories.push({ Type:type, Category:category, Subcategory:"", Active:"Y" });
    return true;
  }

  function ensureSubcategory(type, category, sub){
    type = (type==="Income" ? "Income" : "Expense");
    category = String(category||"").trim();
    sub = String(sub||"").trim();
    if(!category || !sub) return false;

    const exists = (state.categories||[]).some(c =>
      String(c.Active||"Y").toUpperCase()!=="N" &&
      String(c.Type||"Expense").toLowerCase().startsWith(type.toLowerCase().slice(0,3)) &&
      String(c.Category||"").trim().toLowerCase() === category.toLowerCase() &&
      String(c.Subcategory||"").trim().toLowerCase() === sub.toLowerCase()
    );
    if(exists) return true;

    state.categories = state.categories || [];
    state.categories.push({ Type:type, Category:category, Subcategory:sub, Active:"Y" });
    return true;
  }

  function quickAddCategory(type, prefix){
    const label = (type==="Income" ? "income" : "expense");
    const name = prompt("Add a new " + label + " category (name):", "");
    if(name==null) return null;
    const cat = String(name||"").trim();
    if(!cat) return toast("Category name cannot be empty.", "warn");
    ensureCategory(type, cat);
    C.saveSnapshot && C.saveSnapshot("Category added");
    refreshTodaySelectors();
    const sel = $(prefix+"Category");
    if(sel) sel.value = cat;
    rebuildSub(prefix);
    toast("Added category: " + cat, "ok");
    return cat;
  }

  function quickAddSubcategory(type, prefix){
    const catSel = $(prefix+"Category");
    const cat = String(catSel ? catSel.value : "").trim();
    if(!cat) return toast("Pick a category first.", "warn");
    const name = prompt("Add a subcategory under: " + cat, "");
    if(name==null) return null;
    const sub = String(name||"").trim();
    if(!sub) return toast("Subcategory name cannot be empty.", "warn");
    ensureSubcategory(type, cat, sub);
    C.saveSnapshot && C.saveSnapshot("Subcategory added");
    refreshTodaySelectors();
    const subSel = $(prefix+"Subcategory");
    if(subSel) subSel.value = sub;
    toast("Added subcategory: " + cat + " / " + sub, "ok");
    return sub;
  }

  /* ============================
     Categories Manager tab (v2.0)
  ============================ */
  function normType(t){
    return (String(t||"Expense").toLowerCase().startsWith("inc") ? "Income" : "Expense");
  }

  function catKey(type, cat, sub){
    return `${normType(type)}|${String(cat||"").trim().toLowerCase()}|${String(sub||"").trim().toLowerCase()}`;
  }

  function getCategoryRowsForManager(type){
    const want = normType(type);
    const map = new Map();

    // seed from explicit category table (including inactive)
    (state.categories||[]).forEach(c => {
      const t = normType(c.Type);
      if(t !== want) return;
      const cat = String(c.Category||"").trim();
      if(!cat) return;
      const sub = String(c.Subcategory||"").trim();
      const k = catKey(t, cat, sub);
      if(!map.has(k)){
        map.set(k, { Type:t, Category:cat, Subcategory:sub, Active:(String(c.Active||"Y").toUpperCase()==="N"?"N":"Y"), Tax:(String(c.Tax||"").toUpperCase()==="Y"?"Y":""), TaxNote:(c.TaxNote||""), used:0 });
      }else{
        const r = map.get(k);
        if(String(c.Active||"Y").toUpperCase()==="N") r.Active = "N";
        if(String(c.Tax||"").toUpperCase()==="Y") r.Tax = "Y";
        if(String(c.TaxNote||"").trim()) r.TaxNote = String(c.TaxNote);
      }
    });

    // seed from tx (implicit categories)
    (state.tx||[]).forEach(t => {
      const tt = normType(t.Type);
      if(tt !== want) return;
      const cat = String(t.Category||"").trim();
      if(!cat) return;
      const sub = String(t.Subcategory||"").trim();
      const k = catKey(tt, cat, sub);
      if(!map.has(k)) map.set(k, { Type:tt, Category:cat, Subcategory:sub, Active:"Y", Tax:"", TaxNote:"", used:0 });
      map.get(k).used += 1;
    });

    const rows = Array.from(map.values());
    rows.sort((a,b)=> (a.Category+a.Subcategory).localeCompare(b.Category+b.Subcategory));
    return rows;
  }

  function fillCatManagerPicks(){
    const type = normType($("catType")?.value || "Expense");
    const rows = getCategoryRowsForManager(type);
    const cats = uniq(rows.map(r=>r.Category)).sort();
    fillSelectWithBlank($("catPick"), cats, "(pick)");

    const chosenCat = String($("catPick")?.value||"").trim();
    const subs = uniq(rows.filter(r=>r.Category===chosenCat).map(r=>r.Subcategory).filter(Boolean)).sort();
    fillSelectWithBlank($("subPick"), subs, "(all)");
  }

  function renderCategories(){
    if(!$("catRows")) return;
    const type = normType($("catType")?.value || "Expense");
    const q = String($("catSearch")?.value||"").trim().toLowerCase();

    const rows = getCategoryRowsForManager(type).filter(r => {
      if(!q) return true;
      return (r.Category||"").toLowerCase().includes(q) || (r.Subcategory||"").toLowerCase().includes(q);
    });

    $("catRows").innerHTML = rows.map(r => {
      const taxY = String(r.Tax||"").toUpperCase()==="Y";
      const note = String(r.TaxNote||"");
      const noteShort = note.length>60 ? (note.slice(0,57)+"…") : note;
      return `<tr>
        <td>${escapeHtml(r.Type)}</td>
        <td>${escapeHtml(r.Category)}</td>
        <td>${escapeHtml(r.Subcategory || "")}</td>
        <td class="num">${escapeHtml(String(r.used||0))}</td>
        <td>${r.Active==="N" ? "N" : "Y"}</td>
        <td>
          <label class="chk">
            <input class="taxFlag" type="checkbox"
              data-type="${escapeAttr(r.Type)}"
              data-cat="${escapeAttr(r.Category)}"
              data-sub="${escapeAttr(r.Subcategory||"")}"
              ${taxY ? "checked" : ""}>
            <span>Y</span>
          </label>
        </td>
        <td>
          <button class="ghost mini taxNoteBtn" type="button"
            data-type="${escapeAttr(r.Type)}"
            data-cat="${escapeAttr(r.Category)}"
            data-sub="${escapeAttr(r.Subcategory||"")}">Edit</button>
          <span class="sub" style="margin-left:8px">${escapeHtml(noteShort||"")}</span>
        </td>
      </tr>`;
    }).join("") || `<tr><td colspan="7" class="sub">No categories yet.</td></tr>`;

    fillCatManagerPicks();
    $("catMsg") && ($("catMsg").textContent = `Showing ${rows.length} rows.`);
  }

  
  function ensureCategoryRow(type, cat, sub){
    const tnorm = normType(type);
    const Type = (tnorm==="income") ? "Income" : "Expense";
    const Category = String(cat||"").trim();
    const Subcategory = String(sub||"").trim();
    if(!Category) return null;
    const key = catKey(tnorm, Category, Subcategory);
    let row = (state.categories||[]).find(c => catKey(normType(c.Type), String(c.Category||"").trim(), String(c.Subcategory||"").trim()) === key);
    if(!row){
      row = { Type, Category, Subcategory, Active:"Y", Tax:"", TaxNote:"" };
      state.categories.push(row);
    }else{
      // make sure new fields exist
      if(row.Tax === undefined) row.Tax = "";
      if(row.TaxNote === undefined) row.TaxNote = "";
      if(!row.Type) row.Type = Type;
    }
    return row;
  }

  function setCategoryTaxFlag(type, cat, sub, on){
    const row = ensureCategoryRow(type, cat, sub);
    if(!row) return;
    pushUndo("Tax flag");
    row.Tax = on ? "Y" : "";
    toast(on ? "Marked as Tax-related." : "Removed Tax-related mark.");
    renderCategories();
  }

  function setCategoryTaxNote(type, cat, sub){
    const row = ensureCategoryRow(type, cat, sub);
    if(!row) return;
    const current = String(row.TaxNote||"");
    const note = prompt("Tax note (optional):", current);
    if(note === null) return;
    pushUndo("Tax note");
    row.TaxNote = String(note||"").trim();
    toast("Saved tax note.");
    renderCategories();
  }

function updateTxCategory(type, fromCat, fromSub, toCat, toSub){
    const want = normType(type);
    const fc = String(fromCat||"").trim();
    const fs = String(fromSub||"").trim();
    const tc = String(toCat||"").trim();
    const ts = String(toSub||"").trim();
    (state.tx||[]).forEach(t => {
      if(normType(t.Type) !== want) return;
      if(String(t.Category||"").trim() !== fc) return;
      if(fs && String(t.Subcategory||"").trim() !== fs) return;
      t.Category = tc;
      if(fs) t.Subcategory = ts;
      else if(ts) t.Subcategory = ts;
    });
    // budgets are category-level only
    (state.budgets||[]).forEach(b => {
      if(normType(b.Type) !== want) return;
      if(String(b.Category||"").trim() !== fc) return;
      b.Category = tc;
    });
  }

  function deactivateCategoryRows(type, cat, sub){
    const want = normType(type);
    const C0 = String(cat||"").trim().toLowerCase();
    const S0 = String(sub||"").trim().toLowerCase();
    (state.categories||[]).forEach(c => {
      if(normType(c.Type) !== want) return;
      if(String(c.Category||"").trim().toLowerCase() !== C0) return;
      if(S0){
        if(String(c.Subcategory||"").trim().toLowerCase() !== S0) return;
        c.Active = "N";
      }else{
        // deleting whole category: deactivate all rows under it
        c.Active = "N";
      }
    });
  }

  function catAddFlow(){
    const type = normType($("catType")?.value || "Expense");
    const name = prompt(`Add new ${type} category name:`, "");
    if(name==null) return;
    const cat = String(name||"").trim();
    if(!cat) return toast("Category name cannot be empty.", "warn");
    pushUndo("Add category");
    ensureCategory(type, cat);
    markDirty(true);
    rebuildDropdowns();
    renderCategories();
    toast("Added category", "ok", cat);
  }

  function subAddFlow(){
    const type = normType($("catType")?.value || "Expense");
    const cat = String($("catPick")?.value||"").trim();
    if(!cat) return toast("Pick a category first.", "warn");
    const name = prompt(`Add subcategory under: ${cat}`, "");
    if(name==null) return;
    const sub = String(name||"").trim();
    if(!sub) return toast("Subcategory name cannot be empty.", "warn");
    pushUndo("Add subcategory");
    ensureSubcategory(type, cat, sub);
    markDirty(true);
    rebuildDropdowns();
    renderCategories();
    toast("Added subcategory", "ok", `${cat} / ${sub}`);
  }

  function renameFlow(){
    const type = normType($("catType")?.value || "Expense");
    const cat = String($("catPick")?.value||"").trim();
    if(!cat) return toast("Pick a category first.", "warn");
    const sub = String($("subPick")?.value||"").trim();
    const isSub = !!sub;
    const promptLabel = isSub ? `Rename subcategory: ${cat} / ${sub}` : `Rename category: ${cat}`;
    const name = prompt(promptLabel, isSub ? sub : cat);
    if(name==null) return;
    const newName = String(name||"").trim();
    if(!newName) return toast("Name cannot be empty.", "warn");

    pushUndo(isSub ? "Rename subcategory" : "Rename category");

    if(isSub){
      // update explicit categories
      (state.categories||[]).forEach(c => {
        if(normType(c.Type)!==type) return;
        if(String(c.Category||"").trim()!==cat) return;
        if(String(c.Subcategory||"").trim()!==sub) return;
        c.Subcategory = newName;
      });
      // update tx
      (state.tx||[]).forEach(t => {
        if(normType(t.Type)!==type) return;
        if(String(t.Category||"").trim()!==cat) return;
        if(String(t.Subcategory||"").trim()!==sub) return;
        t.Subcategory = newName;
      });
      ensureSubcategory(type, cat, newName);
    }else{
      (state.categories||[]).forEach(c => {
        if(normType(c.Type)!==type) return;
        if(String(c.Category||"").trim()!==cat) return;
        c.Category = newName;
      });
      (state.tx||[]).forEach(t => {
        if(normType(t.Type)!==type) return;
        if(String(t.Category||"").trim()!==cat) return;
        t.Category = newName;
      });
      (state.budgets||[]).forEach(b => {
        if(normType(b.Type)!==type) return;
        if(String(b.Category||"").trim()!==cat) return;
        b.Category = newName;
      });
      ensureCategory(type, newName);
    }

    markDirty(true);
    rebuildDropdowns();
    renderCategories();
    toast("Renamed", "ok", isSub ? `${cat} / ${sub} → ${newName}` : `${cat} → ${newName}`);
  }

  function mergeMoveFlow(){
    const type = normType($("catType")?.value || "Expense");
    const cat = String($("catPick")?.value||"").trim();
    if(!cat) return toast("Pick a category first.", "warn");
    const sub = String($("subPick")?.value||"").trim();

    const toCat = String(prompt("Move into category:", cat) || "").trim();
    if(!toCat) return toast("Target category cannot be empty.", "warn");
    const toSub = String(prompt("Move into subcategory (blank = keep):", sub) || "").trim();

    pushUndo("Merge / move");
    updateTxCategory(type, cat, sub, toCat, toSub);
    ensureCategory(type, toCat);
    if(sub && toSub) ensureSubcategory(type, toCat, toSub);
    markDirty(true);
    rebuildDropdowns();
    renderCategories();
    toast("Moved", "ok", `${cat}${sub?" / "+sub:""} → ${toCat}${toSub?" / "+toSub:""}`);
  }

  function deleteFlow(){
    const type = normType($("catType")?.value || "Expense");
    const cat = String($("catPick")?.value||"").trim();
    if(!cat) return toast("Pick a category first.", "warn");
    const sub = String($("subPick")?.value||"").trim();

    const rows = getCategoryRowsForManager(type);
    const used = rows.filter(r => r.Category===cat && (sub? r.Subcategory===sub : true)).reduce((s,r)=>s+(r.used||0),0);

    const msg = sub ? `Delete subcategory '${sub}' under '${cat}'?` : `Delete category '${cat}' (all subcategories)?`;
    if(!confirm(`${msg}\n\nUsed by ${used} transaction(s).\nYou MUST move existing transactions to another category.`)) return;

    const toCat = String(prompt("Move transactions into category:", "") || "").trim();
    if(!toCat) return toast("Target category cannot be empty.", "warn");
    const toSub = String(prompt("Move into subcategory (optional):", "") || "").trim();

    pushUndo("Delete category/subcategory");
    updateTxCategory(type, cat, sub, toCat, toSub);
    deactivateCategoryRows(type, cat, sub);
    ensureCategory(type, toCat);
    if(toSub) ensureSubcategory(type, toCat, toSub);
    markDirty(true);
    rebuildDropdowns();
    renderCategories();
    toast("Deleted (moved)", "ok", `${cat}${sub?" / "+sub:""} → ${toCat}${toSub?" / "+toSub:""}`);
  }

  function initCategoriesTab(){
    if(!$("catTable")) return;
    on($("catRefreshBtn"), "click", () => renderCategories());
    on($("catType"), "change", () => renderCategories());
    on($("catSearch"), "input", () => renderCategories());
    on($("catPick"), "change", () => fillCatManagerPicks());
    on($("catAddBtn"), "click", () => catAddFlow());
    on($("subAddBtn"), "click", () => subAddFlow());
    on($("catRenameBtn"), "click", () => renameFlow());
    on($("catMergeBtn"), "click", () => mergeMoveFlow());
    on($("catDeleteBtn"), "click", () => deleteFlow());
    // Tax flags + notes (in Categories Manager table)
    on($("catTable"), "change", (e) => {
      const cb = e.target.closest("input.taxFlag");
      if(!cb) return;
      setCategoryTaxFlag(cb.dataset.type, cb.dataset.cat, cb.dataset.sub, cb.checked);
    });
    on($("catTable"), "click", (e) => {
      const btn = e.target.closest("button.taxNoteBtn");
      if(!btn) return;
      setCategoryTaxNote(btn.dataset.type, btn.dataset.cat, btn.dataset.sub);
    });
    renderCategories();
  }

  function initTaxTab(){
    if(!$("taxYear")) return;
    on($("taxRefreshBtn"), "click", () => renderTax());
    on($("taxYear"), "change", () => renderTax());
    on($("taxOnlyTagged"), "change", () => renderTax());
    on($("taxIncludeIncome"), "change", () => renderTax());
    on($("taxIncludeExpense"), "change", () => renderTax());
    on($("taxScope"), "change", () => renderTax());
    on($("taxSearch"), "input", () => {
      if(TYBH.ui._taxSearchT) clearTimeout(TYBH.ui._taxSearchT);
      TYBH.ui._taxSearchT = setTimeout(()=>renderTax(), 150);
    });
  }


  // expose for template buttons
  window.renderCategories = renderCategories;

/* ============================
     Grouped menu dropdowns
  ============================ */
  const NAV_GROUPS = [
    { id: "start",    label: "Start",    tabs: [
      { id: "import",   label: "Import CSV" },
      { id: "overview", label: "Overview" }
    ]},
    { id: "daily",    label: "Daily",    tabs: [
      { id: "today",    label: "Today" },
      { id: "expense",  label: "Add Expense" },
      { id: "income",   label: "Add Income" }
    ]},
    { id: "manage",   label: "Manage",   tabs: [
      { id: "tx",       label: "Transactions" },
      { id: "accounts", label: "Accounts" },
      { id: "categories", label: "Categories" },
      { id: "reconcile", label: "Reconcile" },
      { id: "tax",      label: "Tax View" },
      { id: "budgets",  label: "Budgets" },
      { id: "bills",    label: "Bills" },
      { id: "bulk",     label: "Bulk Edit" }
    ]},
    { id: "planning", label: "Planning", tabs: [
      { id: "goals",    label: "Goals" },
      { id: "grow",     label: "Grow" },
      { id: "gpt",      label: "GPT Pack" },
      { id: "move",     label: "Moving" }
    ]},
    { id: "export",   label: "EXPORT",   tabs: [
      { id: "export",   label: "Export" }
    ]},
    { id: "help",     label: "Help",     tabs: [
      { id: "help",     label: "Quick Guide" },
      { id: "wizard",   label: "Setup Wizard" }
    ]}
  ];

  function getTabLabel(tabId){
    for (const g of NAV_GROUPS){
      for (const t of (g.tabs || [])){
        if (t.id === tabId) return t.label;
      }
    }
    return tabId;
  }

  function setPageTitle(tabId){
    const el = $("pageTitle");
    if (!el) return;
    const label = getTabLabel(tabId || "import");
    el.textContent = label;
  }




    /* ============================
     Modern grouped nav (v4)
  ============================ */
  let _navOpen = false;
  let _navGroupId = (NAV_GROUPS[0] && NAV_GROUPS[0].id) || "start";
  let _navTab = "import";
  let _navOutsideBound = false;

  function setNavOpen(on){
    _navOpen = !!on;
    const drop = $("navDrop");
    if (drop) drop.classList.toggle("hidden", !_navOpen);
  }

  function renderGroupButtons(activeGroupId){
    const wrap = $("navGroups");
    if (!wrap) return;
    wrap.innerHTML = NAV_GROUPS.map(g => {
      const isActive = g.id === activeGroupId;
      return `<a href="#" class="navGroupLink${isActive ? " active" : ""}${g.id==="export" ? " isExport" : ""}" data-group="${escapeAttr(g.id)}" role="button" aria-haspopup="true" aria-expanded="${_navOpen && isActive ? "true" : "false"}">
        <span>${escapeHtml(g.label)}</span><span class="caret">▾</span>
      </a>`;
    }).join("");
  }

  function renderPagesForGroup(groupId, activeTab){
    const g = NAV_GROUPS.find(x => x.id === groupId) || NAV_GROUPS[0];
    if (!g) return;

    _navGroupId = g.id;

    // update groups active state
    document.querySelectorAll("#tyBudgetHub .navGroupLink").forEach(btn => {
      btn.classList.toggle("active", btn.dataset.group === g.id);
    });
    const pagesEl = $("navPages");
    if (!pagesEl) return;
    pagesEl.innerHTML = (g.tabs || []).map(t => {
      const isActive = t.id === activeTab;
      return `<a href="#" class="navPageLink${isActive ? " active" : ""}" data-tab="${escapeAttr(t.id)}" role="button">${escapeHtml(t.label)}</a>`;
    }).join("");
  }

  function findGroupForTab(tab){
    for (const g of NAV_GROUPS){
      if ((g.tabs || []).some(t => t.id === tab)) return g;
    }
    return NAV_GROUPS[0] || null;
  }

  function syncNavToTab(tab){
    _navTab = tab || "import";
    const g = findGroupForTab(_navTab);
    if (!g) return;

    // rebuild group buttons only once if missing
    const ng = $("navGroups");
    if (!ng || !ng.children || !ng.children.length) renderGroupButtons(g.id);

    renderPagesForGroup(g.id, _navTab);
  }

  function toggleGroup(groupId){
    const g = NAV_GROUPS.find(x => x.id === groupId) || NAV_GROUPS[0];
    if (!g) return;

    // if clicking the same active group, toggle dropdown open/close
    const same = (_navGroupId === g.id);
    if (same && _navOpen){
      setNavOpen(false);
      return;
    }

    // open dropdown for this group
    const inGroup = (g.tabs || []).some(t => t.id === _navTab);
    const active = inGroup ? _navTab : ((g.tabs && g.tabs[0] && g.tabs[0].id) ? g.tabs[0].id : _navTab);
    renderPagesForGroup(g.id, active);
    setNavOpen(true);
  }

  function setupNavBar(){
    renderGroupButtons(_navGroupId);
    renderPagesForGroup(_navGroupId, _navTab);

    // group click
    onDelegate($("navGroups"), "click", "a[data-group]", (e, b) => {
      e.preventDefault();
      toggleGroup(b.dataset.group);
    });

    // page click
    onDelegate($("navPages"), "click", "a[data-tab]", (e, b) => {
      e.preventDefault();
      const tab = b.dataset.tab;
      setNavOpen(false);
      if (tab) routeToTab(tab);
    });

    // click outside to close
    if (!_navOutsideBound){
      _navOutsideBound = true;
      document.addEventListener("click", (e) => {
        if (!_navOpen) return;
        const top = $("navTop");
        const drop = $("navDrop");
        const t = e.target;
        if ((top && top.contains(t)) || (drop && drop.contains(t))) return;
        setNavOpen(false);
      }, { passive: true });
    }
  }




  /* ============================
     Top UI Polish (collapse + focus)
  ============================ */
  const UI_PREF_HIDE_CLOUD = "tybh_hideCloudCard";
  const UI_PREF_FOCUS = "tybh_focusMode_v1";
  let _autoCleanDone = false;

  function applyCloudHidden_(hidden){
    const card = $("cloudCard");
    const btn = $("cloudToggleBtn");
    if(card) card.classList.toggle("hidden", !!hidden);
    if(btn) btn.classList.toggle("active", !hidden);
    try{ localStorage.setItem(UI_PREF_HIDE_CLOUD, hidden ? "1" : "0"); }catch(_e){}
  }

  function toggleCloudPanel_(){
    const card = $("cloudCard");
    const hidden = !!(card && card.classList.contains("hidden"));
    applyCloudHidden_(!hidden);
    if(hidden){
      try{ card && card.scrollIntoView({ behavior:"smooth", block:"start" }); }catch(_e){}
    }
  }

  function applyFocusMode_(on){
    const root = document.getElementById("tyBudgetHub");
    if(root) root.classList.toggle("tybhFocus", !!on);
    try{ localStorage.setItem(UI_PREF_FOCUS, on ? "1" : "0"); }catch(_e){}
  }

  function toggleFocusMode_(){
    const root = document.getElementById("tyBudgetHub");
    const on = !!(root && root.classList.contains("tybhFocus"));
    applyFocusMode_(!on);
  }

  function initTopPolish_(){
    // Wire top icon buttons (if present)
    on($("cloudToggleBtn"), "click", (e)=>{ e.preventDefault(); toggleCloudPanel_(); });
    on($("cloudHideBtn"), "click", (e)=>{ e.preventDefault(); applyCloudHidden_(true); });
    on($("focusToggleBtn"), "click", (e)=>{ e.preventDefault(); toggleFocusMode_(); });
    on($("helpBtn"), "click", (e)=>{ e.preventDefault(); try{ routeToTab("help"); }catch(_e){} });

    // Apply saved prefs
    try{
      const hideCloud = (localStorage.getItem(UI_PREF_HIDE_CLOUD)||"0") === "1";
      if(hideCloud) applyCloudHidden_(true);
    }catch(_e){}
    try{
      const focus = (localStorage.getItem(UI_PREF_FOCUS)||"0") === "1";
      if(focus) applyFocusMode_(true);
    }catch(_e){}
  }

  function autoCleanTopAfterLoad_(){
    if(_autoCleanDone) return;
    if(!state || !state.loaded) return;
    if(state._isDemo) return;
    if(!(state.tx && state.tx.length)) return;

    _autoCleanDone = true;

    // Hide Quick Start once real data is loaded (can re-open from Help tab)
    try{ localStorage.setItem("tybh_hideQuickStart", "1"); }catch(_e){}
    try{ $("quickStartCard")?.classList.add("hidden"); $("qsShowRow")?.classList.remove("hidden"); }catch(_e){}

    // Collapse Cloud panel (re-open via ☁ button)
    applyCloudHidden_(true);

    // If user is still sitting on Import, jump to Overview for a cleaner start
    try{
      const active = document.querySelector("#tyBudgetHub .tabbtn.active");
      const activeTab = active ? String(active.dataset.tab||"") : "";
      if(activeTab === "import"){
        try{ localStorage.setItem("tybh_lastTab", "overview"); }catch(_e){}
        routeToTab("overview");
      }
    }catch(_e){}
  }

  /* ============================
     Quick Start + Help + Wizard
  ============================ */
  function initQuickStart(){
    const card = $("quickStartCard");
    const showRow = $("qsShowRow");
    const hideKey = "tybh_hideQuickStart";

    function apply(){
      const hidden = localStorage.getItem(hideKey) === "1";
      if (card) card.classList.toggle("hidden", hidden);
      if (showRow) showRow.classList.toggle("hidden", !hidden);
    }

    // actions
    on($("qsHide"), "click", (e) => {
      e.preventDefault();
      try{ localStorage.setItem(hideKey, "1"); }catch(_){}
      apply();
    });
    on($("qsShow"), "click", (e) => {
      e.preventDefault();
      try{ localStorage.setItem(hideKey, "0"); }catch(_){}
      apply();
      routeToTab("import");
      setTimeout(() => { $("quickStartCard")?.scrollIntoView({ behavior:"smooth", block:"start" }); }, 60);
    });
    on($("qsOpenHelp"), "click", (e) => { e.preventDefault(); routeToTab("help"); });
    on($("qsOpenWizard"), "click", (e) => { e.preventDefault(); routeToTab("wizard"); setWizardStep(0); });

    apply();
  }

  let _wizStep = 0;

  function setWizardStep(step){
    _wizStep = Math.max(0, Math.min(4, Number(step)||0));
    document.querySelectorAll("#tyBudgetHub .wizStep").forEach(b => {
      b.classList.toggle("active", String(b.dataset.step) === String(_wizStep));
    });
    document.querySelectorAll("#tyBudgetHub .wizPane").forEach(p => {
      p.classList.toggle("hidden", String(p.dataset.step) !== String(_wizStep));
    });
    try{ localStorage.setItem("tybh_wizStep", String(_wizStep)); }catch(_){}
  }

  function initHelpAndWizard(){
    // HELP buttons
    on($("helpOpenWizard"), "click", (e)=>{ e.preventDefault(); routeToTab("wizard"); setWizardStep(0); });
    on($("helpShowQuickStart"), "click", (e)=>{
      e.preventDefault();
      try{ localStorage.setItem("tybh_hideQuickStart", "0"); }catch(_){}
      routeToTab("import");
      setTimeout(() => { $("quickStartCard")?.scrollIntoView({ behavior:"smooth", block:"start" }); }, 80);
      // quick start will unhide on next init/apply; also update instantly if available
      $("quickStartCard")?.classList.remove("hidden");
      $("qsShowRow")?.classList.add("hidden");
    });

    on($("helpGoImport"), "click", (e)=>{ e.preventDefault(); routeToTab("import"); });
    on($("helpGoAccounts"), "click", (e)=>{ e.preventDefault(); routeToTab("accounts"); });
    on($("helpGoToday"), "click", (e)=>{ e.preventDefault(); routeToTab("today"); });
    on($("helpGoExport"), "click", (e)=>{ e.preventDefault(); routeToTab("export"); });

    // Wizard navigation
    on($("wizRestart"), "click", (e)=>{ e.preventDefault(); setWizardStep(0); });
    on($("wizGoHelp"), "click", (e)=>{ e.preventDefault(); routeToTab("help"); });

    // step list click
    onDelegate($("tab-wizard"), "click", "button.wizStep", (e, b) => {
      e.preventDefault();
      setWizardStep(b.dataset.step);
    });

    // step 0
    on($("wizLoadDemo"), "click", (e)=>{ e.preventDefault(); loadDemo(); routeToTab("overview"); setWizardStep(2); });
    on($("wizGoImport"), "click", (e)=>{ e.preventDefault(); routeToTab("import"); setWizardStep(1); setTimeout(()=>{ $("fileInput")?.focus(); }, 120); });
    on($("wizNext0"), "click", (e)=>{ e.preventDefault(); setWizardStep(1); });

    // step 1
    on($("wizJumpImport1"), "click", (e)=>{ e.preventDefault(); routeToTab("import"); setTimeout(()=>{ $("fileInput")?.focus(); }, 120); });
    on($("wizBack1"), "click", (e)=>{ e.preventDefault(); setWizardStep(0); });
    on($("wizNext1"), "click", (e)=>{ e.preventDefault(); setWizardStep(2); });

    // step 2
    on($("wizJumpAccounts2"), "click", (e)=>{ e.preventDefault(); routeToTab("accounts"); });
    on($("wizBack2"), "click", (e)=>{ e.preventDefault(); setWizardStep(1); });
    on($("wizNext2"), "click", (e)=>{ e.preventDefault(); setWizardStep(3); });

    // step 3
    on($("wizJumpToday3"), "click", (e)=>{ e.preventDefault(); routeToTab("today"); });
    on($("wizBack3"), "click", (e)=>{ e.preventDefault(); setWizardStep(2); });
    on($("wizNext3"), "click", (e)=>{ e.preventDefault(); setWizardStep(4); });

    // step 4
    on($("wizJumpExport4"), "click", (e)=>{ e.preventDefault(); routeToTab("export"); });
    on($("wizBack4"), "click", (e)=>{ e.preventDefault(); setWizardStep(3); });
    on($("wizDone4"), "click", (e)=>{ e.preventDefault(); routeToTab("help"); });

    // restore last step
    try{
      const last = Number(localStorage.getItem("tybh_wizStep")||"0");
      if (!Number.isNaN(last)) setWizardStep(last);
    }catch(_){}
  }

/* ============================
     Demo banner
  ============================ */
  function updateDemoUI(){
    updateStatusStrip();
    const onDemo = !!state._isDemo;
    const banner = $("demoBanner");
    const badge = $("demoBadge");
    if (banner) banner.classList.toggle("hidden", !onDemo);
    if (badge) badge.classList.toggle("hidden", !onDemo);

    if ($("stStatus") && onDemo && state.loaded){
      $("stStatus").textContent = "Loaded (DEMO)";
    }
  }

  function setDemoMode(on){
    // keep status strip in sync

    state._isDemo = !!on;
    updateDemoUI();
  }

  async function loadDemoFromUrl(url, force){
    if (state.loaded && !force) return;
    const u = url || DEMO_CSV_URL;
    try{
      if ($("stStatus")) $("stStatus").textContent = "Loading demo...";
      if ($("importMsg")) $("importMsg").textContent = "";
      const res = await fetch(u, { cache: "no-store" });
      if (!res.ok) throw new Error("HTTP " + res.status);
      const text = await res.text();
      setDemoMode(true);
      META.dirty = false;
      loadFromMaster(preprocessCsvText(String(text || "")));
      afterLoad();
      updateStatusStrip();
      saveSnapshotNow();
    } catch(err){
      console.error(err);
      // fallback to core demo if available (works even if CDN blocked/offline)
      try{
        if (typeof loadDemoCore === "function"){
          const maybe = loadDemoCore();
          if (typeof maybe === "string" && maybe.trim()){
            setDemoMode(true);
            loadFromMaster(preprocessCsvText(String(maybe)));
            afterLoad();
            return;
          }
          if (state && state.loaded){
            setDemoMode(true);
            afterLoad();
            return;
          }
        }
      } catch(e2){
        console.error(e2);
      }
      setDemoMode(false);
      if ($("stStatus")) $("stStatus").textContent = "Not loaded";
      if ($("importMsg")){
        $("importMsg").innerHTML = `<span class="err">Demo CSV auto-load failed.</span> ${escapeHtml(err?.message || String(err))}`;
      }
    }
  }


  /* ============================
     Tabs
  ============================ */
  const TAB_LIST = [
    "import",
    "overview",
    "today",
    "expense",
    "income",
    "tx",
    "accounts",
    "categories",
    "reconcile",
    "tax",
    "budgets",
    "bills",
    "bulk",
    "goals",
    "grow",
    "gpt",
    "move",
    "export",
    "help",
    "wizard"
  ];

  function showTab(tab) {
    document.querySelectorAll("#tyBudgetHub .tabbtn").forEach((b) => {
      b.classList.toggle("active", b.dataset.tab === tab);
    });
    document.querySelectorAll("#tyBudgetHub .drawerBtn").forEach((b) => {
      b.classList.toggle("active", b.dataset.tab === tab);
    });

    TAB_LIST.forEach((t) => {
      const el = $("tab-" + t);
      if (el) el.classList.toggle("hidden", t !== tab);
    });

    if ($("tabDrawer")) $("tabDrawer").classList.add("hidden");

    setPageTitle(tab);
    syncNavToTab(tab);
    updateDemoUI();

    try {
      localStorage.setItem("tybh_lastTab", tab);
    } catch (e) {}
  }

  function buildTabDrawer() {
    const drawer = $("tabDrawer");
    if (!drawer) return;

    drawer.innerHTML = TAB_LIST.map((t) => {
      const btn = document.querySelector(`#tyBudgetHub .tabbtn[data-tab="${t}"]`);
      const label = btn ? btn.textContent.trim() : t;
      return `<button type="button" class="drawerBtn" data-tab="${escapeAttr(t)}">${escapeHtml(label)}</button>`;
    }).join("");

    drawer.addEventListener("click", (e) => {
      const b = e.target.closest("a[data-tab]");
      if (!b) return;
      routeToTab(b.dataset.tab);
    });
  }

  function routeToTab(tab) {
    if (!state.loaded && !["import","help","wizard"].includes(tab)) {
      if ($("importMsg")) $("importMsg").innerHTML = `<span class="err">Import a CSV first.</span>`;
      showTab("import");
      return;
    }
    showTab(tab);
    if (tab === "tx") renderTx();
    if (tab === "accounts") renderAccounts();
    if (tab === "categories") renderCategories();
    if (tab === "reconcile") renderReconcile();
    if (tab === "tax") renderTax();
    if (tab === "bulk") rebuildBulkUI(true);
    if (tab === "goals") renderGoalsEditor();
    if (tab === "budgets") renderBudgets();
    if (tab === "bills") renderBills();
    if (tab === "move") renderMove();
    if (tab === "grow") renderGrow();
    if (tab === "today") refreshToday();
    if (tab === "overview") renderOverview();
  }

  /* ============================
     Render All
  ============================ */
  function renderAll() {
    if (!state.loaded) return;

    if ($("setCurrency")) state.settings.currency = $("setCurrency").value || "USD";
    if ($("setPeople")) {
      state.settings.people = ($("setPeople").value || "Tin Lei,Tin Wing")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }

    rebuildDropdowns();
    renderOverview();
    renderAccounts();
    renderGoalsEditor();
    renderBudgets();
    renderBills();
    renderMove();
    renderGrow();
    renderTx();
    refreshToday();
  }

  /* ============================
     Overview + Goals Summary
  ============================ */
  function renderGoalsSummary() {
    const wrap = $("goalRows");
    if (!wrap) return;

    const active = (state.goals || []).filter((g) => String(g.Active || "Y").trim().toUpperCase() !== "N");
    if (!active.length) {
      wrap.textContent = "No goals yet.";
      return;
    }

    wrap.innerHTML = active
      .map((g) => {
        const pct =
          g.TargetAmount > 0 ? Math.max(0, Math.min(1, (g.CurrentAmount || 0) / g.TargetAmount)) : 0;
        const p = Math.round(pct * 100);
        return `
        <div style="margin:10px 0">
          <div style="display:flex;justify-content:space-between;gap:10px;flex-wrap:wrap">
            <div style="font-weight:950">${escapeHtml(g.GoalName)}</div>
            <div class="sub">${escapeHtml(money(g.CurrentAmount))} / ${escapeHtml(money(g.TargetAmount))} (${p}%)</div>
          </div>
          <div class="bar"><div style="width:${p}%"></div></div>
          ${g.Notes ? `<div class="sub" style="margin-top:6px">${escapeHtml(g.Notes)}</div>` : ``}
        </div>
      `;
      })
      .join("");
  }

  function renderOverview() {
    if (!state.loaded) return;

    const m = $("monthPick") ? $("monthPick").value : "";
    const rows = monthTx(m);

    let income = 0,
      expense = 0;
    for (const r of rows) {
      if (r.Type === "Income") income += num(r.Amount);
      if (r.Type === "Expense") expense += num(r.Amount);
    }
    const net = income - expense;

    if ($("kIncome")) $("kIncome").textContent = money(income);
    if ($("kExpense")) $("kExpense").textContent = money(expense);
    if ($("kNet")) $("kNet").textContent = money(net);

    if ($("ovNote"))
      $("ovNote").textContent = net >= 0 ? "Good. Net is positive this month." : "Careful. Net is negative this month.";

    const map = new Map();
    for (const r of rows) {
      if (r.Type !== "Expense") continue;
      const k = (r.Category || "(uncat)").trim() || "(uncat)";
      map.set(k, (map.get(k) || 0) + num(r.Amount));
    }
    const list = Array.from(map.entries())
      .map(([category, amount]) => ({ category, amount }))
      .sort((a, b) => b.amount - a.amount);

    if ($("catRows")) {
      $("catRows").innerHTML = (list.length ? list : [{ category: "(none)", amount: 0 }])
        .map((r) => `<tr><td>${escapeHtml(r.category)}</td><td class="num">${escapeHtml(money(r.amount))}</td></tr>`)
        .join("");
    }

    const recent = [...(state.tx || [])].sort((a, b) => (b.Date || "").localeCompare(a.Date || "")).slice(0, 10);
    if ($("recentRows")) {
      $("recentRows").innerHTML = recent.length
        ? recent
            .map((r) => {
              return `<div style="padding:8px 0;border-bottom:1px dashed var(--border)">
          <b>${escapeHtml(r.Type)}</b> ${escapeHtml(money(r.Amount))} — ${escapeHtml(r.Category)}${
                r.Subcategory ? " / " + escapeHtml(r.Subcategory) : ""
              }
          <div class="sub">${escapeHtml(r.Date)} • ${escapeHtml(r.Person)} • ${escapeHtml(r.Account || "—")} ${
                r.Payee ? "• " + escapeHtml(r.Payee) : ""
              }</div>
        </div>`;
            })
            .join("")
        : "No transactions yet.";
    }

    renderGoalsSummary();
  }

  /* ============================
     Rules UI
  ============================ */
  function loadRulesUI() {
    if ($("ruleMode")) $("ruleMode").value = String(state.rules.mode || "BLOCK").toUpperCase();
    if ($("ruleEatCats")) $("ruleEatCats").value = state.rules.eatCats || "";
    if ($("ruleEatWeekly")) $("ruleEatWeekly").value = num(state.rules.eatWeekly) || 0;
    if ($("ruleImpulseWeekly")) $("ruleImpulseWeekly").value = num(state.rules.impulseWeekly) || 0;
    if ($("ruleNonEssCats")) $("ruleNonEssCats").value = state.rules.nonEssCats || "";
    if ($("ruleNonEssDaily")) $("ruleNonEssDaily").value = num(state.rules.nonEssDaily) || 0;

    if ($("ruleMsg")) $("ruleMsg").textContent = "";
    if ($("growInvestMonthly")) $("growInvestMonthly").value = num(state.grow.investMonthly) || 0;
    if ($("growInvestAccount")) $("growInvestAccount").value = state.grow.investAccount || "";
  }

  function saveRules() {
    state.rules.mode = String($("ruleMode")?.value || "BLOCK").toUpperCase();
    state.rules.eatCats = $("ruleEatCats")?.value || "";
    state.rules.eatWeekly = num($("ruleEatWeekly")?.value);
    state.rules.impulseWeekly = num($("ruleImpulseWeekly")?.value);
    state.rules.nonEssCats = $("ruleNonEssCats")?.value || "";
    state.rules.nonEssDaily = num($("ruleNonEssDaily")?.value);

    if ($("ruleMsg")) $("ruleMsg").innerHTML = `<span class="ok">Saved.</span>`;
    refreshToday();
  }

  /* ============================
     Expense / Income forms
  ============================ */
  let pendingExpense = null;

  function clearExpense(keepMsg = false) {
    if ($("exAmount")) $("exAmount").value = "";
    if ($("exPayee")) $("exPayee").value = "";
    if ($("exNotes")) $("exNotes").value = "";
    if ($("exTemplate")) $("exTemplate").value = "";
    if ($("exDate")) $("exDate").value = isoToday();
    if ($("exImpulse")) $("exImpulse").value = "N";
    if ($("exImpulseReason")) $("exImpulseReason").value = "";
    if ($("exWarnBox")) $("exWarnBox").classList.add("hidden");
    pendingExpense = null;
    if (!keepMsg && $("exMsg")) $("exMsg").textContent = "";
  }

  function clearIncome(keepMsg = false) {
    if ($("inAmount")) $("inAmount").value = "";
    if ($("inNotes")) $("inNotes").value = "";
    if ($("inDate")) $("inDate").value = isoToday();
    if (!keepMsg && $("inMsg")) $("inMsg").textContent = "";
  }

  function cancelPendingExpense() {
    pendingExpense = null;
    if ($("exWarnBox")) $("exWarnBox").classList.add("hidden");
    if ($("exMsg")) $("exMsg").innerHTML = `<span class="sub">Okay.</span>`;
  }

  function overridePendingExpense() {
    if (!pendingExpense) return;
    const tx = pendingExpense.tx;
    const warnings = pendingExpense.warnings || [];
    applyFlagsForTx(tx, warnings, true);
    state.tx.push(tx);

    refreshMonthSelectors();
    if ($("txMonth") && $("txMonth").value && $("txMonth").value !== tx.Month) {
      $("txMonth").value = tx.Month;
    }

    pendingExpense = null;
    if ($("exWarnBox")) $("exWarnBox").classList.add("hidden");

    clearExpense(true);
    if ($("exMsg")) $("exMsg").innerHTML = `<span class="ok">Saved (override).</span>`;

    rebuildDropdowns();
    renderOverview();
    renderAccounts();
    renderBudgets();
    refreshToday();
    renderTx();
  }

  function submitExpense() {
    if (!state.loaded) {
      if ($("exMsg")) $("exMsg").innerHTML = `<span class="err">Import first.</span>`;
      return;
    }
    const amount = num($("exAmount")?.value);
    if (amount <= 0) {
      if ($("exMsg")) $("exMsg").innerHTML = `<span class="err">Enter an amount.</span>`;
      return;
    }

    const date = ($("exDate")?.value || isoToday()).slice(0, 10);

    const tx = {
      ID: uid(),
      Date: date,
      Month: toMonth(date),
      Type: "Expense",
      Person: $("exPerson")?.value || "",
      Account: $("exAccount")?.value || "",
      Category: $("exCategory")?.value || "",
      Subcategory: $("exSubcategory")?.value || "",
      Item: $("exTemplate")?.value || "",
      Payee: $("exPayee")?.value || "",
      Amount: amount,
      Notes: $("exNotes")?.value || "",
      Impulse: $("exImpulse")?.value === "Y" ? "Y" : "N",
      ImpulseReason: $("exImpulseReason")?.value || "",
      Flags: ""
    };

    const warnings = evalWarningsForTx(tx, true);
    const mode = String(state.rules.mode || "BLOCK").toUpperCase();

    if (warnings.length && mode === "BLOCK") {
      pendingExpense = { tx, warnings };
      if ($("exWarnList"))
        $("exWarnList").innerHTML = warnings.map((w) => `<div style="margin:6px 0">• ${escapeHtml(w)}</div>`).join("");
      if ($("exWarnBox")) $("exWarnBox").classList.remove("hidden");
      if ($("exMsg"))
        $("exMsg").innerHTML = `<span class="warn">Blocked by guardrails.</span> You can override if unavoidable.`;
      return;
    }

    if (warnings.length && mode === "WARN") {
      applyFlagsForTx(tx, warnings, false);
      if ($("exMsg")) $("exMsg").innerHTML = `<span class="warn">Saved with warning.</span>`;
    } else {
      if ($("exMsg")) $("exMsg").innerHTML = `<span class="ok">Saved.</span>`;
    }

    state.tx.push(tx);

    refreshMonthSelectors();
    if ($("txMonth") && $("txMonth").value && $("txMonth").value !== tx.Month) {
      $("txMonth").value = tx.Month;
    }

    clearExpense(true);
    rebuildDropdowns();
    renderOverview();
    renderAccounts();
    renderBudgets();
    refreshToday();
    renderTx();
  }

  function submitIncome() {
    if (!state.loaded) {
      if ($("inMsg")) $("inMsg").innerHTML = `<span class="err">Import first.</span>`;
      return;
    }
    const amount = num($("inAmount")?.value);
    if (amount <= 0) {
      if ($("inMsg")) $("inMsg").innerHTML = `<span class="err">Enter an amount.</span>`;
      return;
    }

    const date = ($("inDate")?.value || isoToday()).slice(0, 10);

    const tx = {
      ID: uid(),
      Date: date,
      Month: toMonth(date),
      Type: "Income",
      Person: $("inPerson")?.value || "",
      Account: $("inAccount")?.value || "",
      Category: $("inCategory")?.value || "Income",
      Subcategory: $("inSubcategory")?.value || "General",
      Item: "",
      Payee: "",
      Amount: amount,
      Notes: $("inNotes")?.value || "",
      Impulse: "N",
      ImpulseReason: "",
      Flags: ""
    };

    state.tx.push(tx);

    refreshMonthSelectors();
    if ($("txMonth") && $("txMonth").value && $("txMonth").value !== tx.Month) {
      $("txMonth").value = tx.Month;
    }

    clearIncome(true);
    if ($("inMsg")) $("inMsg").innerHTML = `<span class="ok">Saved.</span>`;
    rebuildDropdowns();
    renderOverview();
    renderAccounts();
    renderBudgets();
    refreshToday();
    renderTx();
  }

  /* ============================
     Transactions list + editor
  ============================ */
  let editIndex = -1;
  let pendingEditOverride = null;

  const txSort = { key: "Date", dir: "desc" };

  function sortIcon(key) {
    if (txSort.key !== key) return "";
    return txSort.dir === "asc" ? "▲" : "▼";
  }

  function applyTxSort(rows) {
    const key = txSort.key;
    const dir = txSort.dir === "asc" ? 1 : -1;

    const getVal = (r) => {
      if (key === "Amount") return num(r.Amount);
      return String(r[key] ?? "").toLowerCase();
    };

    rows.sort((a, b) => {
      const av = getVal(a);
      const bv = getVal(b);
      if (typeof av === "number" && typeof bv === "number") {
        return (av - bv) * dir;
      }
      return String(av).localeCompare(String(bv)) * dir;
    });

    return rows;
  }

  function openEditById(id) {
    const tid = String(id || "").trim();
    if (!tid) return;
    const i = (state.tx || []).findIndex((t) => String(t.ID || "").trim() === tid);
    if (i < 0) return;
    openEdit(i);
  }

  function clearTxFilters() {
    if ($("txQ")) $("txQ").value = "";
    if ($("txType")) $("txType").value = "";
    if ($("txAccount")) $("txAccount").value = "";
    if ($("txImpulse")) $("txImpulse").value = "";
    const missEl = $("txMissingAcc");
    if (missEl) missEl.value = "";
    renderTx();
  }

  function renderTx() {
    if (!state.loaded) return;
    if (!$("txRows")) return;

    const m = $("txMonth") ? $("txMonth").value : "";
    const q = ($("txQ")?.value || "").trim().toLowerCase();
    const type = ($("txType")?.value || "").trim();
    const acc = ($("txAccount")?.value || "").trim();
    const imp = ($("txImpulse")?.value || "").trim();
    const missAcc = $("txMissingAcc") ? ($("txMissingAcc").value || "").trim() : "";

    let rows = [...(state.tx || [])];
    if (m) rows = rows.filter((r) => r.Month === m);
    if (type) rows = rows.filter((r) => r.Type === type);
    if (acc) rows = rows.filter((r) => String(r.Account || "").trim() === acc);
    if (imp) rows = rows.filter((r) => String(r.Impulse || "N").toUpperCase() === imp);
    if (missAcc === "Y") rows = rows.filter((r) => !String(r.Account || "").trim());

    if (q) {
      rows = rows.filter((r) => {
        const hay = `${r.Date} ${r.Type} ${r.Person} ${r.Account} ${r.Category} ${r.Subcategory} ${r.Item} ${r.Payee} ${r.Notes} ${r.Impulse} ${r.ImpulseReason} ${r.Flags}`.toLowerCase();
        return hay.includes(q);
      });
    }

    applyTxSort(rows);

    if ($("txMeta"))
      $("txMeta").textContent =
        `Showing ${rows.length} row(s)` + (m ? ` • Month ${m}` : ` • All months`);

    if (!rows.length) {
      $("txRows").textContent = "No data for current filters.";
      closeEdit();
      return;
    }

    $("txRows").innerHTML = `
      <div class="tableWrap">
        <table class="tytbl" id="txTable">
          <thead>
            <tr>
              <th class="sortTh" data-sort="Date">Date <span class="sortIcon">${escapeHtml(sortIcon("Date"))}</span></th>
              <th class="sortTh" data-sort="Type">Type <span class="sortIcon">${escapeHtml(sortIcon("Type"))}</span></th>
              <th class="sortTh" data-sort="Category">Category <span class="sortIcon">${escapeHtml(sortIcon("Category"))}</span></th>
              <th class="sortTh" data-sort="Person">Person <span class="sortIcon">${escapeHtml(sortIcon("Person"))}</span></th>
              <th class="sortTh" data-sort="Account">Account <span class="sortIcon">${escapeHtml(sortIcon("Account"))}</span></th>
              <th class="sortTh num" data-sort="Amount">Amount <span class="sortIcon">${escapeHtml(sortIcon("Amount"))}</span></th>
              <th>Payee / Notes</th>
              <th>Flags</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            ${rows
              .map((r) => {
                const flags = String(r.Flags || "").trim();
                const impPill =
                  String(r.Impulse || "N").toUpperCase() === "Y" ? `<span class="pill orange">Impulse</span>` : ``;
                const noAccPill = !String(r.Account || "").trim() ? `<span class="pill soft">No Acc</span>` : ``;
                const overPill = flags.includes("overbudget") ? `<span class="pill red">Over</span>` : ``;
                const ovPill = flags.includes("override") ? `<span class="pill soft">Override</span>` : ``;
                const scopePill = String(r.Scope||"Personal").toLowerCase()==="business" ? `<span class="pill blue">Business</span>` : ``;

                return `
                <tr>
                  <td>${escapeHtml(r.Date)}</td>
                  <td>${escapeHtml(r.Type)}</td>
                  <td class="wrap">${escapeHtml(r.Category)}${r.Subcategory ? " / " + escapeHtml(r.Subcategory) : ""}</td>
                  <td>${escapeHtml(r.Person)}</td>
                  <td>${escapeHtml(r.Account || "—")}</td>
                  <td class="num">${escapeHtml(money(r.Amount))}</td>
                  <td class="wrap">${escapeHtml(r.Payee || "")}${r.Notes ? " — " + escapeHtml(r.Notes) : ""} ${r.Receipt ? ` <a class="miniLink" href="${escapeAttr(r.Receipt)}" target="_blank" rel="noopener">receipt</a>` : ""} ${
                  r.ImpulseReason
                    ? `<div class="sub">Impulse reason: ${escapeHtml(r.ImpulseReason)}</div>`
                    : ""
                }</td>
                  <td class="wrap">${noAccPill} ${impPill} ${overPill} ${ovPill} ${scopePill}</td>
                  <td><a class="editLink" href="javascript:void(0)" data-action="edit" data-id="${escapeAttr(
                    r.ID
                  )}">edit</a></td>
                </tr>
              `;
              })
              .join("")}
          </tbody>
        </table>
      </div>
    `;
  }

  function openEdit(i) {
    editIndex = i;
    const r = state.tx[i];
    if (!r) return;

    fillSelect($("edPerson"), state.settings.people || []);
    fillSelectWithBlank(
      $("edAccount"),
      uniq((state.accounts || []).map((a) => a.Account)).sort(),
      "(unassigned)"
    );

    function catsFor(type) {
      const cats = uniq((state.tx || []).filter((t) => t.Type === type).map((t) => t.Category)).sort();
      if (cats.length) return cats;
      return [type === "Income" ? "Income" : "Other"];
    }

    if ($("edType")) {
      $("edType").onchange = () => {
        const t = $("edType").value;
        fillSelect($("edCategory"), catsFor(t));
        rebuildEditSub();
      };
    }
    if ($("edCategory")) $("edCategory").onchange = () => rebuildEditSub();

    if ($("edId")) $("edId").value = r.ID;
    if ($("edIdPill")) $("edIdPill").textContent = r.ID;

    if ($("edDate")) $("edDate").value = r.Date;
    if ($("edType")) $("edType").value = r.Type;

    fillSelect($("edCategory"), catsFor(r.Type));
    if ($("edCategory")) $("edCategory").value = r.Category || $("edCategory").value;

    if ($("edPerson")) $("edPerson").value = r.Person || (state.settings.people || [])[0] || "";
    if ($("edAccount")) $("edAccount").value = r.Account || "";
    if ($("edAmount")) $("edAmount").value = num(r.Amount);

    rebuildEditSub();
    if ($("edSubcategory")) $("edSubcategory").value = r.Subcategory || $("edSubcategory").value;

    if ($("edPayee")) $("edPayee").value = r.Payee || "";
    if ($("edNotes")) $("edNotes").value = r.Notes || "";
    if ($("edScope")) $("edScope").value = r.Scope || "Personal";
    if ($("edReceipt")) $("edReceipt").value = r.Receipt || "";

    if ($("edImpulse")) $("edImpulse").value = String(r.Impulse || "N").toUpperCase() === "Y" ? "Y" : "N";
    if ($("edImpulseReason")) $("edImpulseReason").value = r.ImpulseReason || "";

    const flags = String(r.Flags || "").trim();
    if ($("edFlagPills")) {
      if (flags) {
        $("edFlagPills").textContent = "Flags: " + flags;
        $("edFlagPills").classList.remove("hidden");
      } else {
        $("edFlagPills").classList.add("hidden");
      }
    }

    if ($("editMsg")) $("editMsg").textContent = "";
    if ($("edOverrideBtn")) $("edOverrideBtn").classList.add("hidden");
    pendingEditOverride = null;

    if ($("txEditorCard")) $("txEditorCard").classList.remove("hidden");
    try {
      $("txEditorCard")?.scrollIntoView({ behavior: "smooth", block: "start" });
    } catch (e) {}
  }

  function rebuildEditSub() {
    const r = state.tx[editIndex];
    if (!$("edCategory") || !$("edSubcategory")) return;

    const cat = $("edCategory").value;
    const typ = $("edType") ? $("edType").value || (r ? r.Type : "Expense") : r ? r.Type : "Expense";
    const subs = uniq((state.tx || []).filter((t) => t.Type === typ && t.Category === cat).map((t) => t.Subcategory)).sort();
    fillSelect($("edSubcategory"), subs.length ? subs : ["General"]);
  }

  function closeEdit() {
    if ($("txEditorCard")) $("txEditorCard").classList.add("hidden");
    if ($("editMsg")) $("editMsg").textContent = "";
    if ($("edIdPill")) $("edIdPill").textContent = "—";
    if ($("edOverrideBtn")) $("edOverrideBtn").classList.add("hidden");
    pendingEditOverride = null;
    editIndex = -1;
  }

  function saveEdit() {
    const i = editIndex;
    if (i < 0) return;
    const r = state.tx[i];
    if (!r) return;

    const amt = num($("edAmount")?.value);
    if (amt <= 0) {
      if ($("editMsg")) $("editMsg").innerHTML = `<span class="err">Amount must be &gt; 0</span>`;
      return;
    }

    const updated = { ...r };

    updated.Date = ($("edDate")?.value || isoToday()).slice(0, 10);
    updated.Month = toMonth(updated.Date);
    updated.Type = $("edType")?.value || updated.Type;
    updated.Person = $("edPerson")?.value || "";
    updated.Account = $("edAccount")?.value || "";
    updated.Amount = amt;
    updated.Category = $("edCategory")?.value || "";
    updated.Subcategory = $("edSubcategory")?.value || "";
    updated.Payee = $("edPayee")?.value || "";
    updated.Notes = $("edNotes")?.value || "";
    updated.Impulse = $("edImpulse")?.value === "Y" ? "Y" : "N";
    updated.ImpulseReason = $("edImpulseReason")?.value || "";

    const warnings = evalWarningsForTx(updated, true);
    const mode = String(state.rules.mode || "BLOCK").toUpperCase();

    if (warnings.length && mode === "BLOCK") {
      pendingEditOverride = { updated, warnings };
      if ($("editMsg")) {
        $("editMsg").innerHTML =
          `<span class="warn">Blocked by guardrails.</span><div style="margin-top:6px">${warnings
            .map((w) => `• ${escapeHtml(w)}`)
            .join("<br>")}</div>`;
      }
      if ($("edOverrideBtn")) $("edOverrideBtn").classList.remove("hidden");
      return;
    }

    if (warnings.length && mode === "WARN") {
      applyFlagsForTx(updated, warnings, false);
      if ($("editMsg")) $("editMsg").innerHTML = `<span class="warn">Saved with warning.</span>`;
    } else {
      updated.Flags = String(updated.Flags || "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean)
        .filter((f) => f !== "overbudget")
        .join(",");
      if ($("editMsg")) $("editMsg").innerHTML = `<span class="ok">Saved.</span>`;
    }

    state.tx[i] = updated;

    rebuildDropdowns();
    refreshMonthSelectors();
    renderOverview();
    markDirty(true);
    renderTx();
    renderAccounts();
    renderBudgets();
    refreshToday();

    const id = updated.ID;
    const newIdx = state.tx.findIndex((t) => t.ID === id);
    if (newIdx >= 0) {
      editIndex = newIdx;
      setTimeout(() => openEdit(newIdx), 0);
    } else {
      closeEdit();
    }
  }

  function overrideSaveEdit() {
    if (!pendingEditOverride) return;
    const i = editIndex;
    if (i < 0) return;

    const updated = pendingEditOverride.updated;
    const warnings = pendingEditOverride.warnings || [];
    applyFlagsForTx(updated, warnings, true);

    state.tx[i] = updated;
    pendingEditOverride = null;

    if ($("edOverrideBtn")) $("edOverrideBtn").classList.add("hidden");
    if ($("editMsg")) $("editMsg").innerHTML = `<span class="ok">Saved (override).</span>`;

    rebuildDropdowns();
    refreshMonthSelectors();
    renderOverview();
    renderTx();
    renderAccounts();
    renderBudgets();
    refreshToday();

    const id = updated.ID;
    const newIdx = state.tx.findIndex((t) => t.ID === id);
    if (newIdx >= 0) {
      editIndex = newIdx;
      setTimeout(() => openEdit(newIdx), 0);
    }
  }

  function deleteEdit() {
    const i = editIndex;
    if (i < 0) return;
    const r = state.tx[i];
    if (!r) return;
    if (!confirm("Delete this transaction?")) return;

    state.tx.splice(i, 1);
    rebuildDropdowns();
    refreshMonthSelectors();
    renderOverview();
    markDirty(true);
    renderTx();
    renderAccounts();
    renderBudgets();
    refreshToday();
    closeEdit();
  }

  /* ============================
     Accounts UI
  ============================ */
  function renderAccounts() {
    if (!state.loaded) return;
    if (!$("accRows")) return;

    mergeAccountsByName();

    if (!state.accounts.length) {
      $("accRows").innerHTML = `<div class="sub">No accounts yet.</div>`;
      return;
    }

    const rows = state.accounts.map((a, i) => ({ ...a, _i: i }));
    $("accRows").innerHTML = `
      <div class="tableWrap">
        <table class="tytbl">
          <thead>
            <tr>
              <th style="min-width:220px">Account</th>
              <th style="min-width:160px">Owner</th>
              <th style="min-width:160px">Type</th>
              <th style="min-width:150px">Nature</th>
              <th class="num" style="min-width:150px">Start</th>
              <th class="num" style="min-width:150px">Computed</th>
              <th class="num" style="min-width:170px">Bank (manual)</th>
              <th class="num" style="min-width:160px">Diff</th>
              <th style="min-width:110px">Active</th>
              <th style="min-width:110px"></th>
            </tr>
          </thead>
          <tbody>
            ${rows
              .map((a) => {
                const computed = computedBalanceFor(a.Account);
                const bank = String(a.BankBalance ?? "").trim() === "" ? "" : num(a.BankBalance);
                const diff = bank === "" ? "" : num(bank) - computed;
                const dim = String(a.Active || "Y").toUpperCase() === "N" ? "dim" : "";
                return `
                <tr class="${dim}">
                  <td class="wrap"><b>${escapeHtml(a.Account)}</b></td>
                  <td class="wrap"><input data-acc-idx="${a._i}" data-acc-field="Owner" value="${escapeAttr(
                  a.Owner || ""
                )}" style="width:100%"></td>
                  <td class="wrap"><input data-acc-idx="${a._i}" data-acc-field="Type" value="${escapeAttr(
                  a.Type || ""
                )}" style="width:100%"></td>
                  <td>
                    <select data-acc-idx="${a._i}" data-acc-field="Nature">
                      <option value="ASSET" ${
                        String(a.Nature || "ASSET").toUpperCase() === "ASSET" ? "selected" : ""
                      }>ASSET</option>
                      <option value="LIABILITY" ${
                        String(a.Nature || "ASSET").toUpperCase() === "LIABILITY" ? "selected" : ""
                      }>LIABILITY</option>
                    </select>
                  </td>
                  <td class="num"><input data-acc-idx="${a._i}" data-acc-field="StartBalance" type="number" step="0.01" value="${escapeAttr(
                  num(a.StartBalance)
                )}" style="width:140px;text-align:right"></td>
                  <td class="num"><span data-acc-computed="${a._i}">${escapeHtml(money(computed))}</span></td>
                  <td class="num"><input data-acc-idx="${a._i}" data-acc-field="BankBalance" type="number" step="0.01" value="${escapeAttr(
                  bank
                )}" style="width:160px;text-align:right"></td>
                  <td class="num"><span data-acc-diff="${a._i}">${diff === "" ? "" : escapeHtml(money(diff))}</span></td>
                  <td>
                    <select data-acc-idx="${a._i}" data-acc-field="Active">
                      <option value="Y" ${String(a.Active || "Y").toUpperCase() === "Y" ? "selected" : ""}>Y</option>
                      <option value="N" ${String(a.Active || "Y").toUpperCase() === "N" ? "selected" : ""}>N</option>
                    </select>
                  </td>
                  <td><button class="danger mini" type="button" data-action="remove-acc" data-acc-idx="${a._i}">Remove</button></td>
                </tr>
              `;
              })
              .join("")}
          </tbody>
        </table>
      </div>
    `;

    if ($("accMsg")) $("accMsg").textContent = "";
    rebuildBulkUI(true);
  }

  function updateAccountRow(i) {
    const a = state.accounts[i];
    if (!a) return;
    const computed = computedBalanceFor(a.Account);
    const bank = String(a.BankBalance ?? "").trim() === "" ? "" : num(a.BankBalance);
    const diff = bank === "" ? "" : num(bank) - computed;

    const cEl = document.querySelector(`[data-acc-computed="${i}"]`);
    const dEl = document.querySelector(`[data-acc-diff="${i}"]`);
    if (cEl) cEl.textContent = money(computed);
    if (dEl) dEl.textContent = diff === "" ? "" : money(diff);
  }

  /* ============================
     Reconcile (statement check)
  ============================ */
  function _firstDayOfMonthISO(iso){
    const d = new Date(String(iso||"").slice(0,10) + "T00:00:00");
    if(!isFinite(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth()+1).padStart(2,"0");
    return `${y}-${m}-01`;
  }

  
  function getTaxYears(){
    const ys = new Set();
    (state.tx||[]).forEach(t=>{
      const d = String(t.Date||"").trim();
      if(/^(\d{4})-\d{2}-\d{2}$/.test(d)) ys.add(d.slice(0,4));
      else if(/^(\d{4})\//.test(d)) ys.add(d.slice(0,4));
    });
    return Array.from(ys).sort((a,b)=>b.localeCompare(a));
  }

  function categoryIsTaxRelated(type, cat, sub){
    const want = normType(type);
    cat = String(cat||"").trim();
    sub = String(sub||"").trim();
    if(!cat) return false;
    const key = catKey(want, cat, sub);
    const row = (state.categories||[]).find(c => catKey(normType(c.Type), String(c.Category||"").trim(), String(c.Subcategory||"").trim()) === key);
    return row && String(row.Tax||"").toUpperCase()==="Y";
  }

  function buildTaxSummary(year, opts){
    opts = opts || {};
    const onlyTagged = !!opts.onlyTagged;
    const includeIncome = opts.includeIncome!==false;
    const includeExpense = opts.includeExpense!==false;
    const q = String(opts.q||"").trim().toLowerCase();
    const scope = String(opts.scope||"all").toLowerCase();

    const incomeMap = new Map();
    const expenseMap = new Map();
    const monthly = {}; // {YYYY-MM: {inc, exp}}

    function addTo(map, cat, sub, amt){
      const k = (cat+"|"+sub).toLowerCase();
      const it = map.get(k) || {Category:cat, Subcategory:sub, Total:0, Count:0};
      it.Total += amt;
      it.Count += 1;
      map.set(k, it);
    }

    (state.tx||[]).forEach(t=>{
      const d = String(t.Date||"").trim();
      if(!d || d.slice(0,4) !== String(year)) return;
      const type = normType(t.Type||"Expense");
      const txScope = String(t.Scope||"Personal").trim().toLowerCase();
      if(scope!=="all"){
        if(scope==="business" && txScope!=="business") return;
        if(scope==="personal" && txScope!=="personal") return;
      }
      if(type==="income" && !includeIncome) return;
      if(type==="expense" && !includeExpense) return;

      const cat = String(t.Category||"").trim() || "(Uncategorized)";
      const sub = String(t.Subcategory||"").trim();

      if(onlyTagged){
        if(!(categoryIsTaxRelated(type, cat, sub))) return;
      }

      if(q){
        const hay = [
          t.Payee, t.Notes, t.Item, t.Account, t.Person, t.Category, t.Subcategory, t.Type, t.Amount, t.Date
        ].map(x=>String(x||"").toLowerCase()).join(" | ");
        if(!hay.includes(q)) return;
      }

      const amt = num(t.Amount);
      const month = (t.Month && String(t.Month).trim()) ? String(t.Month).trim() : toMonth(d);
      const mkey = String(month||"").slice(0,7) || (String(year)+"-??");

      if(!monthly[mkey]) monthly[mkey] = {inc:0, exp:0};

      if(type==="income"){
        addTo(incomeMap, cat, sub, amt);
        monthly[mkey].inc += amt;
      }else{
        addTo(expenseMap, cat, sub, amt);
        monthly[mkey].exp += amt;
      }
    });

    const income = Array.from(incomeMap.values()).sort((a,b)=>(b.Total-a.Total)||((a.Category+a.Subcategory).localeCompare(b.Category+b.Subcategory)));
    const expense = Array.from(expenseMap.values()).sort((a,b)=>(b.Total-a.Total)||((a.Category+a.Subcategory).localeCompare(b.Category+b.Subcategory)));

    const months = Object.keys(monthly).sort((a,b)=>a.localeCompare(b)).filter(k=>k.startsWith(String(year)));

    const incTotal = income.reduce((s,x)=>s+x.Total,0);
    const expTotal = expense.reduce((s,x)=>s+x.Total,0);

    return {
      year:String(year),
      income,
      expense,
      monthlyRows: months.map(m=>{
        const inc = monthly[m].inc || 0;
        const exp = monthly[m].exp || 0;
        return {Month:m, Income:inc, Expense:exp, Net:(inc-exp)};
      }),
      incTotal, expTotal, net:(incTotal-expTotal)
    };
  }

  function downloadTaxSummaryCsv(summary, opts){
    opts = opts || {};
    const onlyTagged = !!opts.onlyTagged;
    const rows = [];
    rows.push(["Year","Mode","ScopeFilter","Type","Category","Subcategory","Total","TxCount","TaxRelated","TaxNote"]);
    function pushType(type, arr){
      arr.forEach(r=>{
        const rel = categoryIsTaxRelated(type, r.Category, r.Subcategory) ? "Y" : "";
        const noteRow = (state.categories||[]).find(c => catKey(normType(c.Type), String(c.Category||"").trim(), String(c.Subcategory||"").trim()) === catKey(normType(type), r.Category, r.Subcategory));
        const note = noteRow ? String(noteRow.TaxNote||"") : "";
        rows.push([summary.year, (onlyTagged?"ONLY_TAGGED":"ALL"), String(opts.scope||"all"), type, r.Category, r.Subcategory, fmtMoney(r.Total), String(r.Count), rel, note]);
      });
    }
    pushType("Income", summary.income);
    pushType("Expense", summary.expense);

    const csv = toCsv(rows);
    const filename = `bb-budget_tax-summary_${summary.year}${onlyTagged ? "_tagged" : ""}.csv`;
    downloadText(filename, csv);
  }

  function downloadTaxTypeCsv(typeWanted, summary, opts){
    opts = opts || {};
    const onlyTagged = !!opts.onlyTagged;
    const scopeFilter = String(opts.scope||"all");
    const rows = [];
    rows.push(["Year","Mode","ScopeFilter","Type","Category","Subcategory","Total","TxCount","TaxRelated","TaxNote"]);
    const arr = (String(typeWanted).toLowerCase()==="income") ? (summary.income||[]) : (summary.expense||[]);
    const typeLabel = (String(typeWanted).toLowerCase()==="income") ? "Income" : "Expense";
    arr.forEach(r=>{
      const rel = categoryIsTaxRelated(typeLabel, r.Category, r.Subcategory) ? "Y" : "";
      const noteRow = (state.categories||[]).find(c => catKey(normType(c.Type), String(c.Category||"").trim(), String(c.Subcategory||"").trim()) === catKey(normType(typeLabel), r.Category, r.Subcategory));
      const note = noteRow ? String(noteRow.TaxNote||"") : "";
      rows.push([summary.year, (onlyTagged?"ONLY_TAGGED":"ALL"), scopeFilter, typeLabel, r.Category, r.Subcategory, fmtMoney(r.Total), String(r.Count), rel, note]);
    });
    const csv = toCsv(rows);
    const filename = `bb-budget_tax-${typeLabel.toLowerCase()}_${summary.year}${onlyTagged ? "_tagged" : ""}${scopeFilter!=="all" ? "_"+scopeFilter : ""}.csv`;
    downloadText(filename, csv);
  }


  
  function ensureTaxDom(){
    const host = $("tab-tax");
    if(!host) return;

    // If key controls are missing, inject a full Tax View UI so user never sees a blank tab.
    if($("taxYear") && $("taxIncomeRows") && $("taxExpenseRows") && $("taxMonthlyRows")) return;

    host.innerHTML = `
      <div style="display:flex;justify-content:space-between;gap:10px;flex-wrap:wrap;align-items:center">
        <div style="font-weight:950">Tax View (Year Summary)</div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end">
          <button class="ghost mini" type="button" id="taxRefreshBtn">Refresh</button>
          <button class="ghost mini" type="button" id="taxExportIncomeBtn">Export Income CSV</button>
          <button class="ghost mini" type="button" id="taxExportExpenseBtn">Export Expense CSV</button>
          <button class="mini" type="button" id="taxExportBtn">Export Full Summary CSV</button>
        </div>
      </div>

      <div class="note" style="margin-top:8px">
        This does <b>not</b> file taxes. It prepares clean yearly totals you can give to an accountant or tax software.
        Use <b>Categories Manager</b> to mark categories as <b>Tax-related</b> if you want a clean filtered view.
      </div>

      <div class="row" style="margin-top:10px;gap:10px;flex-wrap:wrap;align-items:flex-end">
        <div class="field" style="min-width:220px">
          <label>Year</label>
          <select id="taxYear"></select>
        </div>

        <div class="field" style="min-width:220px">
          <label>Scope</label>
          <select id="taxScope">
            <option value="all">All</option>
            <option value="personal">Personal</option>
            <option value="business">Business</option>
          </select>
        </div>

        <div class="field" style="min-width:220px">
          <label>Filters</label>
          <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:center;padding:8px 10px;border:1px solid var(--border);border-radius:12px;background:var(--soft)">
            <label style="display:flex;gap:8px;align-items:center;margin:0">
              <input type="checkbox" id="taxOnlyTagged">
              <span>Only Tax-related</span>
            </label>
            <label style="display:flex;gap:8px;align-items:center;margin:0">
              <input type="checkbox" id="taxInc" checked>
              <span>Include Income</span>
            </label>
            <label style="display:flex;gap:8px;align-items:center;margin:0">
              <input type="checkbox" id="taxExp" checked>
              <span>Include Expense</span>
            </label>
          </div>
        </div>

        <div class="field" style="min-width:240px">
          <label>Search</label>
          <input id="taxSearch" placeholder="search payee / notes / category / account">
        </div>
      </div>

      <div id="taxMsg" class="sub" style="margin-top:10px"></div>
      <div id="taxSummaryCards" class="row" style="margin-top:12px;gap:10px;flex-wrap:wrap"></div>

      <div class="row" style="margin-top:12px;gap:10px;flex-wrap:wrap">
        <div class="card" style="flex:1;min-width:320px">
          <div style="font-weight:900;margin-bottom:8px">Income Totals</div>
          <div class="tableWrap">
            <table class="tbl">
              <thead><tr><th>Category</th><th>Subcategory</th><th class="right">Total</th><th class="right">Count</th></tr></thead>
              <tbody id="taxIncomeRows"></tbody>
            </table>
          </div>
        </div>

        <div class="card" style="flex:1;min-width:320px">
          <div style="font-weight:900;margin-bottom:8px">Expense Totals</div>
          <div class="tableWrap">
            <table class="tbl">
              <thead><tr><th>Category</th><th>Subcategory</th><th class="right">Total</th><th class="right">Count</th><th>Receipt</th></tr></thead>
              <tbody id="taxExpenseRows"></tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card" style="margin-top:12px">
        <div style="font-weight:900;margin-bottom:8px">Monthly Breakdown</div>
        <div class="tableWrap">
          <table class="tbl">
            <thead><tr><th>Month</th><th class="right">Income</th><th class="right">Expense</th><th class="right">Net</th></tr></thead>
            <tbody id="taxMonthlyRows"></tbody>
          </table>
        </div>
      </div>
    `;
  }

function renderTax(){
    if(!state.loaded) return;
    ensureTaxDom();
    const yearSel = $("taxYear");
    if(!yearSel){
      const host = $("tab-tax");
      if(host) host.innerHTML = `<div class="note"><b>Tax View failed to load.</b> Please refresh the page.</div>`;
      return;
    }

    const years = getTaxYears();
    if(!years.length){
      yearSel.innerHTML = `<option value="">(no dated transactions)</option>`;
      if($("taxMsg")) $("taxMsg").innerHTML = `<span class="err">No transactions found with a valid date.</span>`;
      $("taxIncomeRows").innerHTML = "";
      $("taxExpenseRows").innerHTML = "";
      $("taxMonthlyRows").innerHTML = "";
      $("taxSummaryCards").innerHTML = "";
      return;
    }

    const cur = yearSel.value && years.includes(yearSel.value) ? yearSel.value : years[0];
    yearSel.innerHTML = years.map(y=>`<option value="${escapeAttr(y)}"${y===cur?' selected':''}>${escapeHtml(y)}</option>`).join("");

    // show/hide onlyTagged option based on whether there are any tagged categories
    const anyTagged = (state.categories||[]).some(c=>String(c.Tax||"").toUpperCase()==="Y");
    const onlyTaggedEl = $("taxOnlyTagged");
    if(onlyTaggedEl){
      onlyTaggedEl.disabled = !anyTagged;
      if(!anyTagged) onlyTaggedEl.checked = false;
    }

    const opts = {
      onlyTagged: !!$("taxOnlyTagged")?.checked,
      includeIncome: !!$("taxIncludeIncome")?.checked,
      includeExpense: !!$("taxIncludeExpense")?.checked,
      q: $("taxSearch")?.value || "",
          scope: $("taxScope")?.value || "all"
    };

    const sum = buildTaxSummary(cur, opts);

    // summary cards
    const cardsWrap = $("taxSummaryCards");
    if(cardsWrap){
      cardsWrap.innerHTML = [
        `<div class="statCard"><div class="k">Income</div><div class="v">${fmtMoney(sum.incTotal)}</div></div>`,
        `<div class="statCard"><div class="k">Expense</div><div class="v">${fmtMoney(sum.expTotal)}</div></div>`,
        `<div class="statCard"><div class="k">Net</div><div class="v">${fmtMoney(sum.net)}</div></div>`
      ].join("");
    }

    // tables
    $("taxIncomeRows").innerHTML = sum.income.length ? sum.income.map(r=>(
      `<tr><td>${escapeHtml(r.Category)}</td><td>${escapeHtml(r.Subcategory||"")}</td><td class="num">${fmtMoney(r.Total)}</td><td class="num">${r.Count}</td></tr>`
    )).join("") : `<tr><td colspan="4" class="sub">No income rows.</td></tr>`;

    $("taxExpenseRows").innerHTML = sum.expense.length ? sum.expense.map(r=>(
      `<tr><td>${escapeHtml(r.Category)}</td><td>${escapeHtml(r.Subcategory||"")}</td><td class="num">${fmtMoney(r.Total)}</td><td class="num">${r.Count}</td></tr>`
    )).join("") : `<tr><td colspan="4" class="sub">No expense rows.</td></tr>`;

    $("taxMonthlyRows").innerHTML = sum.monthlyRows.length ? sum.monthlyRows.map(r=>(
      `<tr><td>${escapeHtml(r.Month)}</td><td class="num">${fmtMoney(r.Income)}</td><td class="num">${fmtMoney(r.Expense)}</td><td class="num">${fmtMoney(r.Net)}</td></tr>`
    )).join("") : `<tr><td colspan="4" class="sub">No months.</td></tr>`;

    if($("taxMsg")){
      $("taxMsg").textContent = (opts.onlyTagged ? "Showing only Tax-related categories." : "Showing all categories.")
        + " Use Export to download a clean summary CSV.";
    }

    // wire export
    const exBtn = $("taxExportBtn");
    if(exBtn && !exBtn._bound){
      exBtn._bound = true;
      exBtn.addEventListener("click", ()=>{
        const sum2 = buildTaxSummary($("taxYear").value, {
          onlyTagged: !!$("taxOnlyTagged")?.checked,
          includeIncome: !!$("taxIncludeIncome")?.checked,
          includeExpense: !!$("taxIncludeExpense")?.checked,
          q: $("taxSearch")?.value || ""
        });
        downloadTaxSummaryCsv(sum2, { onlyTagged: !!$("taxOnlyTagged")?.checked });
        toast("Exported tax summary CSV.");
      });
    }

    const exIncBtn = $("taxExportIncomeBtn");
    if(exIncBtn && !exIncBtn._bound){
      exIncBtn._bound = true;
      exIncBtn.addEventListener("click", ()=>{
        const sum2 = buildTaxSummary($("taxYear").value, {
          onlyTagged: !!$("taxOnlyTagged")?.checked,
          includeIncome: true,
          includeExpense: false,
          q: $("taxSearch")?.value || "",
          scope: $("taxScope")?.value || "all"
        });
        downloadTaxTypeCsv("Income", sum2, { onlyTagged: !!$("taxOnlyTagged")?.checked, scope: $("taxScope")?.value || "all" });
        toast("Exported income CSV.");
      });
    }

    const exExpBtn = $("taxExportExpenseBtn");
    if(exExpBtn && !exExpBtn._bound){
      exExpBtn._bound = true;
      exExpBtn.addEventListener("click", ()=>{
        const sum2 = buildTaxSummary($("taxYear").value, {
          onlyTagged: !!$("taxOnlyTagged")?.checked,
          includeIncome: false,
          includeExpense: true,
          q: $("taxSearch")?.value || "",
          scope: $("taxScope")?.value || "all"
        });
        downloadTaxTypeCsv("Expense", sum2, { onlyTagged: !!$("taxOnlyTagged")?.checked, scope: $("taxScope")?.value || "all" });
        toast("Exported expense CSV.");
      });
    }

  }

function renderReconcile(){
    if(!state.loaded) return;
    const sel = $("recAccount");
    if(!sel) return;

    mergeAccountsByName();
    const names = (state.accounts||[])
      .filter(a=>String(a.Active||"Y").toUpperCase()!=="N")
      .map(a=>a.Account)
      .filter(Boolean)
      .sort((a,b)=>a.localeCompare(b));

    sel.innerHTML = names.map(n=>`<option value="${escapeAttr(n)}">${escapeHtml(n)}</option>`).join("");

    // defaults
    const today = new Date();
    const endISO = today.toISOString().slice(0,10);
    if($("recEnd") && !$("recEnd").value) $("recEnd").value = endISO;
    const sISO = _firstDayOfMonthISO($("recEnd") ? $("recEnd").value : endISO);
    if($("recStart") && !$("recStart").value) $("recStart").value = sISO;

    // clear outputs
    if($("recOpen")) $("recOpen").textContent = "—";
    if($("recIncome")) $("recIncome").textContent = "—";
    if($("recExpense")) $("recExpense").textContent = "—";
    if($("recNet")) $("recNet").textContent = "—";
    if($("recExpected")) $("recExpected").textContent = "—";
    if($("recDiff")) $("recDiff").textContent = "—";
    if($("recRows")) $("recRows").innerHTML = "";
    if($("recTxHint")) $("recTxHint").textContent = "—";
    if($("recMsg")) $("recMsg").textContent = "";

    // filters
    if($("recFilter")) $("recFilter").value = "all";
    if($("recSearch")) $("recSearch").value = "";
    TYBH.ui._recLast = null;
  }

  function resetReconcile(){
    if($("recBankBal")) $("recBankBal").value = "";
    if($("recStart")) $("recStart").value = "";
    if($("recEnd")) $("recEnd").value = "";
    renderReconcile();
  }

  function runReconcile(){
    if(!state.loaded) return;
    const account = $("recAccount") ? $("recAccount").value : "";
    const s = $("recStart") ? $("recStart").value : "";
    const e = $("recEnd") ? $("recEnd").value : "";
    const bankRaw = $("recBankBal") ? $("recBankBal").value : "";
    const bank = String(bankRaw||"").trim()==="" ? null : num(bankRaw);

    if(!account){
      if($("recMsg")) $("recMsg").innerHTML = `<span class="err">Pick an account.</span>`;
      return;
    }
    if(!s || !e){
      if($("recMsg")) $("recMsg").innerHTML = `<span class="err">Pick a statement start and end date.</span>`;
      return;
    }
    if(bank===null){
      if($("recMsg")) $("recMsg").innerHTML = `<span class="err">Enter statement ending balance.</span>`;
      return;
    }

    const led = reconcileLedger(account, s, e);
    const open = led.openBal;
    const expected = led.expectedEnd;
    const diff = num(bank) - num(expected);

    // keep last reconcile in memory for filters
    TYBH.ui._recLast = {
      account,
      startISO: s,
      endISO: e,
      bank,
      diff,
      led
    };

    if($("recOpen")) $("recOpen").textContent = money(open);
    if($("recIncome")) $("recIncome").textContent = money(led.incomeTotal || 0);
    if($("recExpense")) $("recExpense").textContent = money(led.expenseTotal || 0);
    if($("recNet")) $("recNet").textContent = money(led.netEffect || 0);
    if($("recExpected")) $("recExpected").textContent = money(expected);
    if($("recDiff")) $("recDiff").textContent = money(diff);

    const abs = Math.abs(diff);
    if($("recMsg")){
      if(abs < 0.005){
        $("recMsg").innerHTML = `<span class="ok"><b>Matched.</b></span> Your statement ending balance matches the computed balance.`;
      }else{
        $("recMsg").innerHTML = `<span class="err"><b>Not matched.</b></span> Difference is ${escapeHtml(money(diff))}. Usually this means: missing transaction, wrong amount, wrong date, or wrong Start Balance.`;
      }
    }

    recRenderRows(led.rows);

    // if not matched, gently hint the quick filters
    if(abs >= 0.005){
      const f = $("recFilter");
      if(f && f.value === "all"){
        // leave user choice, but show a helpful hint
        if($("recMsg")){
          $("recMsg").innerHTML += `<div class="sub" style="margin-top:6px">Try: <b>Uncategorized</b>, <b>Last 10</b>, or <b>Round amounts</b> using Quick Filter above.</div>`;
        }
      }
    }
  }

  function recRowMatchesSearch(r, q){
    if(!q) return true;
    const s = String(q||"").trim().toLowerCase();
    if(!s) return true;
    const hay = [r.Date, r.Type, r.Category, r.Payee, money(r.Amount), money(r.Effect), money(r.Running)]
      .join(" |")
      .toLowerCase();
    return hay.includes(s);
  }

  function recApplyFilters(){
    if(!TYBH.ui._recLast || !TYBH.ui._recLast.led) return;
    const led = TYBH.ui._recLast.led;
    const mode = $("recFilter") ? $("recFilter").value : "all";
    const q = $("recSearch") ? $("recSearch").value : "";

    let rows = [...(led.rows||[])];
    if(mode === "uncat"){
      rows = rows.filter(r=>{
        const c = String(r.Category||"").trim();
        return !c || c.toLowerCase()==="uncategorized";
      });
    }else if(mode === "last10"){
      rows = rows.slice(-10);
    }else if(mode === "round"){
      rows = rows.filter(r=>{
        const a = num(r.Amount);
        return Math.abs(a - Math.round(a)) < 0.00001;
      });
    }

    rows = rows.filter(r=>recRowMatchesSearch(r, q));
    recRenderRows(rows);
  }

  function recClearFilters(){
    if($("recFilter")) $("recFilter").value = "all";
    if($("recSearch")) $("recSearch").value = "";
    if(!TYBH.ui._recLast || !TYBH.ui._recLast.led) return;
    recRenderRows(TYBH.ui._recLast.led.rows);
  }

  function recRenderRows(rows){
    const list = rows || [];
    if($("recTxHint")) $("recTxHint").textContent = `${list.length} tx`;
    const body = $("recRows");
    if(!body) return;
    body.innerHTML = list.map(r=>{
      const eff = num(r.Effect);
      const effTxt = money(eff);
      const runTxt = money(r.Running);
      return `<tr>
        <td>${escapeHtml(r.Date)}</td>
        <td>${escapeHtml(r.Type)}</td>
        <td class="wrap">${escapeHtml(r.Category)}</td>
        <td class="wrap">${escapeHtml(r.Payee)}</td>
        <td class="num">${escapeHtml(money(r.Amount))}</td>
        <td class="num">${escapeHtml(effTxt)}</td>
        <td class="num">${escapeHtml(runTxt)}</td>
      </tr>`;
    }).join("") || `<tr><td colspan="7" class="sub">No transactions in range.</td></tr>`;
  }

  function toggleAddAccountForm(force) {
    if (!state.loaded) return;
    const card = $("accAddCard");
    if (!card) return;
    const want = typeof force === "boolean" ? force : card.classList.contains("hidden");
    card.classList.toggle("hidden", !want);
    if ($("accAddMsg")) $("accAddMsg").textContent = "";
    if (want) {
      setTimeout(() => {
        try {
          $("accNewName")?.focus();
        } catch (e) {}
      }, 0);
    }
  }

  function confirmAddAccount() {
    if (!state.loaded) return;
    const name = String($("accNewName")?.value || "").trim();
    if (!name) {
      if ($("accAddMsg")) $("accAddMsg").innerHTML = `<span class="err">Account name is required.</span>`;
      return;
    }

    const owner = String($("accNewOwner")?.value || "").trim();
    const type = String($("accNewType")?.value || "").trim();
    const nature = String($("accNewNature")?.value || "ASSET").toUpperCase() === "LIABILITY" ? "LIABILITY" : "ASSET";
    const start = num($("accNewStart")?.value);

    state.accounts.push({ Account: name, Owner: owner, Type: type, Nature: nature, StartBalance: start, BankBalance: "", Active: "Y" });
    mergeAccountsByName();
    rebuildDropdowns();
    renderAccounts();

    if ($("accNewName")) $("accNewName").value = "";
    if ($("accNewOwner")) $("accNewOwner").value = "";
    if ($("accNewType")) $("accNewType").value = "";
    if ($("accNewStart")) $("accNewStart").value = "";
    if ($("accAddMsg")) $("accAddMsg").innerHTML = `<span class="ok">Added.</span>`;
  }

  /* ============================
     Budgets UI
  ============================ */
  function budgetsFor(month, type) {
    const m = String(month || "").trim();
    const t = String(type || "Expense").trim();
    return (state.budgets || [])
      .map((b, i) => ({ ...b, _i: i }))
      .filter((b) => b.Month === m && b.Type === t && String(b.Category || "").trim());
  }

  function renderBudgets() {
    if (!state.loaded) return;
    if (!$("budRows")) return;

    const m = $("budMonth") ? $("budMonth").value || ymToday() : ymToday();
    const t = $("budType") ? $("budType").value || "Expense" : "Expense";

    const rows = budgetsFor(m, t);
    const cats = uniq((state.tx || []).filter((x) => x.Type === t).map((x) => x.Category)).sort();

    if (!rows.length) {
      $("budRows").innerHTML = `
        <tr>
          <td colspan="7" class="wrap">
            <div class="note">
              No budgets for ${escapeHtml(m)} yet.
              <br>Click <b>Add Budget Row</b> and set budgets for categories like Eat Out, Grocery, Cats, Move Fund.
            </div>
          </td>
        </tr>
      `;
      if ($("budMsg")) $("budMsg").textContent = "";
      refreshToday();
      return;
    }

    $("budRows").innerHTML = rows
      .map((b) => {
        const isActive = String(b.Active || "Y").toUpperCase() !== "N";
        const spent =
          t === "Expense"
            ? spentFor(m, t, b.Category)
            : sumTxWhere((x) => x.Month === m && x.Type === t && x.Category === b.Category);
        const remain = num(b.BudgetAmount) - spent;
        const pct = num(b.BudgetAmount) > 0 ? Math.max(0, Math.min(1, spent / num(b.BudgetAmount))) : 0;
        const p = Math.round(pct * 100);
        const dim = isActive ? "" : "dim";

        return `
        <tr data-bud-i="${b._i}" class="${dim}">
          <td class="wrap"><input data-bud-field="Category" list="catList" value="${escapeAttr(b.Category)}" style="width:100%"></td>
          <td class="num"><input data-bud-field="BudgetAmount" type="number" step="0.01" value="${escapeAttr(num(b.BudgetAmount))}" style="width:140px;text-align:right"></td>
          <td class="num">${escapeHtml(money(spent))}</td>
          <td class="num">${escapeHtml(money(remain))}</td>
          <td class="wrap"><input data-bud-field="Notes" value="${escapeAttr(b.Notes || "")}" style="width:100%"></td>
          <td>
            <select data-bud-field="Active">
              <option value="Y" ${String(b.Active || "Y").toUpperCase() === "Y" ? "selected" : ""}>Y</option>
              <option value="N" ${String(b.Active || "Y").toUpperCase() === "N" ? "selected" : ""}>N</option>
            </select>
          </td>
          <td>
            <button class="danger mini" type="button" data-action="del-bud" data-bud-i="${b._i}">Remove</button>
            <div class="sub" style="margin-top:6px">
              <div class="bar"><div style="width:${p}%"></div></div>
              <div class="sub">${p}% used</div>
            </div>
          </td>
        </tr>
      `;
      })
      .join("");

    let dl = document.getElementById("catList");
    if (!dl) {
      dl = document.createElement("datalist");
      dl.id = "catList";
      document.body.appendChild(dl);
    }
    dl.innerHTML = cats.map((c) => `<option value="${escapeAttr(c)}"></option>`).join("");

    if ($("budMsg")) $("budMsg").textContent = "";
    refreshToday();
  }

  function addBudgetRow() {
    if (!state.loaded) return;
    const m = $("budMonth") ? $("budMonth").value || ymToday() : ymToday();
    const t = $("budType") ? $("budType").value || "Expense" : "Expense";
    const guess = t === "Expense" ? "Eat Out" : "Income";
    state.budgets.push({ Month: m, Type: t, Category: guess, BudgetAmount: 0, Notes: "", Active: "Y" });
    renderBudgets();
    if ($("budMsg")) $("budMsg").innerHTML = `<span class="ok">Added.</span> Set the budget amount and category.`;
    refreshToday();
  }

  /* ============================
     Bills UI
  ============================ */
  function renderBills() {
    if (!state.loaded) return;
    if (!$("billRows")) return;

    const rows = state.bills || [];
    const accounts = uniq((state.accounts || []).map((a) => a.Account).concat((state.tx || []).map((t) => t.Account))).sort();

    if (!rows.length) {
      $("billRows").innerHTML = `
        <tr><td colspan="8" class="wrap">
          <div class="note">No bills yet. Add recurring bills like rent, phone, internet, insurance.</div>
        </td></tr>
      `;
      if ($("billMsg")) $("billMsg").textContent = "";
      refreshToday();
      return;
    }

    $("billRows").innerHTML = rows
      .map(
        (b, idx) => `
      <tr data-bill-idx="${idx}" class="${String(b.Active || "Y").toUpperCase() === "N" ? "dim" : ""}">
        <td class="wrap"><input data-bill-field="BillName" value="${escapeAttr(b.BillName || "")}" style="width:100%"></td>
        <td class="num"><input data-bill-field="Amount" type="number" step="0.01" value="${escapeAttr(num(b.Amount))}" style="width:140px;text-align:right"></td>
        <td><input data-bill-field="DueDay" type="number" min="1" max="31" value="${escapeAttr(num(b.DueDay) || 1)}" style="width:100px"></td>
        <td class="wrap">
          <select data-bill-field="Account" style="width:100%">
            <option value="">(none)</option>
            ${accounts
              .map((a) => `<option value="${escapeAttr(a)}" ${a === b.Account ? "selected" : ""}>${escapeHtml(a)}</option>`)
              .join("")}
          </select>
        </td>
        <td>
          <select data-bill-field="AutoPay">
            <option value="Y" ${String(b.AutoPay || "N").toUpperCase() === "Y" ? "selected" : ""}>Y</option>
            <option value="N" ${String(b.AutoPay || "N").toUpperCase() === "N" ? "selected" : ""}>N</option>
          </select>
        </td>
        <td class="wrap"><input data-bill-field="Notes" value="${escapeAttr(b.Notes || "")}" style="width:100%"></td>
        <td>
          <select data-bill-field="Active">
            <option value="Y" ${String(b.Active || "Y").toUpperCase() === "Y" ? "selected" : ""}>Y</option>
            <option value="N" ${String(b.Active || "Y").toUpperCase() === "N" ? "selected" : ""}>N</option>
          </select>
        </td>
        <td><button class="danger mini" type="button" data-action="del-bill" data-bill-idx="${idx}">Remove</button></td>
      </tr>
    `
      )
      .join("");

    if ($("billMsg")) $("billMsg").textContent = "";
    refreshToday();
  }

  function addBill() {
    if (!state.loaded) return;
    state.bills.push({ BillName: "New Bill", Amount: 0, DueDay: 1, Account: "", AutoPay: "N", Notes: "", Active: "Y" });
    renderBills();
    if ($("billMsg")) $("billMsg").innerHTML = `<span class="ok">Added.</span>`;
  }

  /* ============================
     Move UI
  ============================ */
  function addMoveItem() {
    if (!state.loaded) return;
    state.move.push({ Item: "New Item", Kind: "One-time", Amount: 0, Notes: "", Active: "Y" });
    renderMove();
    if ($("moveMsg")) $("moveMsg").innerHTML = `<span class="ok">Added.</span>`;
  }

  function renderMove() {
    if (!state.loaded) return;
    if (!$("moveRows")) return;

    const rows = state.move || [];
    const m = $("moveMonth") ? $("moveMonth").value || ymToday() : ymToday();

    const baseRows = monthTx(m);
    const inc = baseRows.filter((x) => x.Type === "Income").reduce((a, x) => a + num(x.Amount), 0);
    const exp = baseRows.filter((x) => x.Type === "Expense").reduce((a, x) => a + num(x.Amount), 0);
    const net = inc - exp;

    const active = rows.filter((x) => String(x.Active || "Y").toUpperCase() !== "N");
    const oneTime = active.filter((x) => String(x.Kind || "One-time") !== "Monthly").reduce((a, x) => a + num(x.Amount), 0);
    const monthly = active.filter((x) => String(x.Kind || "One-time") === "Monthly").reduce((a, x) => a + num(x.Amount), 0);

    const netAfter = net - monthly;
    let msg = `Base net (${m}): ${money(net)} • Move monthly change: ${money(monthly)} • Net after: ${money(netAfter)} • One-time total: ${money(oneTime)}`;

    if (oneTime > 0) {
      if (netAfter > 0) {
        const months = Math.ceil(oneTime / netAfter);
        msg += ` • Months to save (rough): ${months}`;
      } else {
        msg += ` • Months to save: not possible (net after ≤ 0)`;
      }
    }

    if ($("moveSummary")) $("moveSummary").textContent = msg;

    if (!rows.length) {
      $("moveRows").innerHTML = `
        <tr><td colspan="6" class="wrap">
          <div class="note">No move items yet. Add one-time costs (deposit, truck) and monthly changes (rent difference).</div>
        </td></tr>
      `;
      return;
    }

    $("moveRows").innerHTML = rows
      .map(
        (it, idx) => `
      <tr data-move-idx="${idx}" class="${String(it.Active || "Y").toUpperCase() === "N" ? "dim" : ""}">
        <td class="wrap"><input data-move-field="Item" value="${escapeAttr(it.Item || "")}" style="width:100%"></td>
        <td>
          <select data-move-field="Kind">
            <option value="One-time" ${String(it.Kind || "One-time") === "One-time" ? "selected" : ""}>One-time</option>
            <option value="Monthly" ${String(it.Kind || "One-time") === "Monthly" ? "selected" : ""}>Monthly</option>
          </select>
        </td>
        <td class="num"><input data-move-field="Amount" type="number" step="0.01" value="${escapeAttr(num(it.Amount))}" style="width:140px;text-align:right"></td>
        <td class="wrap"><input data-move-field="Notes" value="${escapeAttr(it.Notes || "")}" style="width:100%"></td>
        <td>
          <select data-move-field="Active">
            <option value="Y" ${String(it.Active || "Y").toUpperCase() === "Y" ? "selected" : ""}>Y</option>
            <option value="N" ${String(it.Active || "Y").toUpperCase() === "N" ? "selected" : ""}>N</option>
          </select>
        </td>
        <td><button class="danger mini" type="button" data-action="del-move" data-move-idx="${idx}">Remove</button></td>
      </tr>
    `
      )
      .join("");

    if ($("moveMsg")) $("moveMsg").textContent = "";
  }

  /* ============================
     Grow UI
  ============================ */
  function saveGrow() {
    state.grow.investMonthly = num($("growInvestMonthly")?.value);
    state.grow.investAccount = String($("growInvestAccount")?.value || "").trim();
    if ($("growMsg")) $("growMsg").innerHTML = `<span class="ok">Saved.</span>`;
    renderGrow();
  }

  function renderGrow() {
    if (!state.loaded) return;
    if ($("growInvestMonthly")) $("growInvestMonthly").value = num(state.grow.investMonthly) || 0;
    if ($("growInvestAccount")) $("growInvestAccount").value = state.grow.investAccount || "";

    const m = ymToday();
    const dep = (state.tx || [])
      .filter((t) => t.Month === m && t.Type === "Expense" && String(t.Category || "").trim().toLowerCase() === "investing deposit")
      .reduce((a, t) => a + num(t.Amount), 0);

    const target = num(state.grow.investMonthly) || 0;
    const remain = Math.max(0, target - dep);

    if ($("growThisMonth")) {
      $("growThisMonth").innerHTML = `
        Target: <b>${escapeHtml(money(target))}</b> • Logged: <b>${escapeHtml(money(dep))}</b> • Remaining: <b>${escapeHtml(money(remain))}</b>
        <div class="sub" style="margin-top:6px">Month: ${escapeHtml(m)} • Account: ${escapeHtml(state.grow.investAccount || "—")}</div>
      `;
    }
  }

  function quickAddInvestDeposit() {
    if (!state.loaded) return;
    routeToTab("expense");
    if ($("exDate")) $("exDate").value = isoToday();
    if ($("exImpulse")) $("exImpulse").value = "N";
    if ($("exImpulseReason")) $("exImpulseReason").value = "";

    const cats = $("exCategory") ? Array.from($("exCategory").options).map((o) => o.value) : [];
    const want = cats.find((c) => String(c).toLowerCase() === "investing deposit") || "Investing Deposit";
    if ($("exCategory")) $("exCategory").value = want;
    rebuildSub("ex");

    if ($("exPayee")) $("exPayee").value = state.grow.investAccount || $("exPayee").value;
    if (num(state.grow.investMonthly) > 0 && $("exAmount")) $("exAmount").value = num(state.grow.investMonthly);
    if ($("exNotes")) $("exNotes").value = "";
    try { $("exAmount")?.focus(); } catch (e) {}
  }

  function quickGoBudgets() { routeToTab("budgets"); }
  function quickGoExpense() { routeToTab("expense"); }

  /* ============================
     Expense quick buttons (v2.2.4)
     - Fix inline button handlers: Eat Out / Grocery / Copy Last / Today
     - These are called by snippet inline onclick="..." so MUST be global.
  ============================ */

  function _setSelectByTextContains(sel, needle){
    if(!sel) return "";
    const want = String(needle||"").trim().toLowerCase();
    if(!want) return "";
    let best = "";
    const opts = Array.from(sel.options || []);
    // exact match first
    for(const o of opts){
      const v = String(o.value||"").trim();
      if(v && v.toLowerCase() === want){ best = v; break; }
    }
    // contains match
    if(!best){
      for(const o of opts){
        const v = String(o.value||"").trim();
        if(v && v.toLowerCase().includes(want)){ best = v; break; }
      }
    }
    if(best) sel.value = best;
    return best;
  }

  function _focusExpenseAmount(){
    try{ $("exAmount")?.focus(); }catch(_){ }
  }

  function quickPresetEatOut(){
    try{
      routeToTab("expense");
      const cat = _setSelectByTextContains($("exCategory"), "eat out") || _setSelectByTextContains($("exCategory"), "dining") || _setSelectByTextContains($("exCategory"), "restaurant");
      if(cat){
        rebuildSub("ex");
        if($("exSubcategory") && !$("exSubcategory").value) $("exSubcategory").value = "General";
        toast("Preset: Eat Out", "ok");
      }else{
        toast("Preset failed", "warn", "No 'Eat Out' category found. Add it in Manage → Categories.");
      }
      _focusExpenseAmount();
    }catch(e){ toast("Preset failed", "err"); }
  }

  function quickPresetGrocery(){
    try{
      routeToTab("expense");
      const cat = _setSelectByTextContains($("exCategory"), "grocery") || _setSelectByTextContains($("exCategory"), "groceries");
      if(cat){
        rebuildSub("ex");
        if($("exSubcategory") && !$("exSubcategory").value) $("exSubcategory").value = "General";
        toast("Preset: Grocery", "ok");
      }else{
        toast("Preset failed", "warn", "No 'Grocery' category found. Add it in Manage → Categories.");
      }
      _focusExpenseAmount();
    }catch(e){ toast("Preset failed", "err"); }
  }

  function setExpenseToday(){
    try{
      if($("exDate")) $("exDate").value = isoToday();
      toast("Date set to today", "ok");
    }catch(_){ }
  }

  function copyLastSimilar(){
    try{
      if(!state.loaded){ toast("Import first", "warn"); return; }
      routeToTab("expense");
      const cat = String($("exCategory")?.value || "").trim();
      if(!cat){
        toast("Pick a category first", "warn", "Then use Copy Last.");
        return;
      }
      const found = [...(state.tx||[])].reverse().find(t => String(t.Type||"") === "Expense" && String(t.Category||"").trim() === cat);
      if(!found){
        toast("Nothing to copy", "warn", "No previous expense found in this category.");
        return;
      }

      // keep today's date by default
      if($("exAccount") && found.Account) $("exAccount").value = found.Account;
      if($("exSubcategory") && found.Subcategory){
        rebuildSub("ex");
        $("exSubcategory").value = found.Subcategory;
      }
      if($("exTemplate") && found.Item) $("exTemplate").value = found.Item;
      if($("exPayee")) $("exPayee").value = found.Payee || "";
      if($("exNotes")) $("exNotes").value = found.Notes || "";
      if($("exAmount") && num(found.Amount)>0) $("exAmount").value = num(found.Amount);

      toast("Copied last expense", "ok", "You can edit amount/date then Save.");
      _focusExpenseAmount();
    }catch(e){ toast("Copy failed", "err"); }
  }

  /* ============================
     Today UI
  ============================ */
  function plannedRemainForMonth(month) {
    const m = String(month || "").trim();
    const buds = (state.budgets || []).filter((b) => b.Month === m && b.Type === "Expense" && String(b.Active || "Y").toUpperCase() !== "N");
    if (!buds.length) return 0;
    let remain = 0;
    for (const b of buds) {
      const spent = spentFor(m, "Expense", b.Category);
      remain += num(b.BudgetAmount) - spent;
    }
    return remain;
  }

  function refreshToday() {
    if (!state.loaded) return;

    const m = $("todayMonth") ? $("todayMonth").value || ymToday() : ymToday();
    const focus = $("todayFocusCat") ? $("todayFocusCat").value || "" : "";

    const now = new Date();
    const plannedRemain = plannedRemainForMonth(m);
    if ($("kPlannedRemain")) $("kPlannedRemain").textContent = money(plannedRemain);

    // safe-to-spend
    const dlm = Math.max(1, (U.daysLeftInMonth ? U.daysLeftInMonth(now) : 1));
    const safeToday = plannedRemain > 0 ? plannedRemain / dlm : 0;
    const weeksLeft = Math.max(1, Math.ceil(dlm / 7));
    const safeWeek = plannedRemain > 0 ? plannedRemain / weeksLeft : 0;

    if ($("kSafeToday")) $("kSafeToday").textContent = money(safeToday);
    if ($("kSafeWeek")) $("kSafeWeek").textContent = money(safeWeek);

    const budRows = (state.budgets || [])
      .filter((b) => b.Month === m && b.Type === "Expense" && String(b.Active || "Y").toUpperCase() !== "N")
      .filter((b) => !focus || String(b.Category || "") === focus);

    if ($("todayBudgetRows")) {
      if (!budRows.length) {
        $("todayBudgetRows").innerHTML = `<tr><td colspan="5" class="wrap"><div class="note">No active budgets for ${escapeHtml(m)}${focus ? " / " + escapeHtml(focus) : ""}. Go to <b>Budgets</b> tab and add a few.</div></td></tr>`;
        if ($("todayBudgetHint")) $("todayBudgetHint").textContent = "";
      } else {
        $("todayBudgetRows").innerHTML = budRows
          .map((b) => {
            const bud = num(b.BudgetAmount);
            const spent = spentFor(m, "Expense", b.Category);
            const rem = bud - spent;
            const pct = bud > 0 ? Math.max(0, Math.min(1, spent / bud)) : 0;
            const p = Math.round(pct * 100);
            return `
            <tr>
              <td class="wrap"><b>${escapeHtml(b.Category)}</b></td>
              <td class="num">${escapeHtml(money(bud))}</td>
              <td class="num">${escapeHtml(money(spent))}</td>
              <td class="num">${escapeHtml(money(rem))}</td>
              <td>
                <div class="bar"><div style="width:${p}%"></div></div>
                <div class="sub" style="margin-top:6px">${p}% used</div>
              </td>
            </tr>
          `;
          })
          .join("");
        if ($("todayBudgetHint"))
          $("todayBudgetHint").textContent = focus ? `Showing focus category: ${focus}` : `Showing all active budgets for ${m}`;
      }
    }

    const impRows = (state.tx || []).filter((t) => t.Month === m && t.Type === "Expense" && String(t.Impulse || "N").toUpperCase() === "Y");
    const impSum = impRows.reduce((a, t) => a + num(t.Amount), 0);

    const impByCat = new Map();
    for (const t of impRows) {
      const k = String(t.Category || "(uncat)");
      impByCat.set(k, (impByCat.get(k) || 0) + num(t.Amount));
    }
    const topImp = Array.from(impByCat.entries()).sort((a, b) => b[1] - a[1]).slice(0, 6);

    if ($("todayImpulse")) {
      $("todayImpulse").innerHTML = impRows.length
        ? `Count: <b>${impRows.length}</b> • Total: <b>${escapeHtml(money(impSum))}</b>` +
          (topImp.length
            ? `<div class="sub" style="margin-top:6px">Top: ${topImp
                .map(([k, v]) => `${escapeHtml(k)} (${escapeHtml(money(v))})`)
                .join(" • ")}</div>`
            : ``)
        : `No impulse spending recorded for ${escapeHtml(m)}.`;
    }

    const upcoming = billsDueNext7Days();
    if ($("todayBills")) {
      $("todayBills").innerHTML = upcoming.length
        ? upcoming
            .map(
              (x) => `<div style="padding:8px 0;border-bottom:1px dashed var(--border)">
            <b>${escapeHtml(x.BillName)}</b> — ${escapeHtml(money(x.Amount))} • due <b>${escapeHtml(x.DueISO)}</b>${x.Account ? " • " + escapeHtml(x.Account) : ""}${String(x.AutoPay || "N").toUpperCase() === "Y" ? " • Autopay" : ""}
            ${x.Notes ? `<div class="sub">${escapeHtml(x.Notes)}</div>` : ""}
          </div>`
            )
            .join("")
        : `No bills due in the next 7 days.`;
    }

    const hasBud = (state.budgets || []).some((b) => b.Month === m && b.Type === "Expense" && String(b.Active || "Y").toUpperCase() !== "N");
    if ($("todayNote"))
      $("todayNote").textContent = hasBud
        ? `Budgets loaded for ${m}. Planned remaining helps control daily spending.`
        : `No budgets for ${m}. Add budgets to enable safe-to-spend guidance.`;
  }

  /* ============================
     Bulk UI
  ============================ */
  function rebuildBulkUI(force) {
    if (!state.loaded) return;

    const catType = $("bkCatType") ? $("bkCatType").value || "" : "";
    const subType = $("bkSubType") ? $("bkSubType").value || "" : "";

    const catsAll = uniq((state.tx || []).filter((t) => !catType || t.Type === catType).map((t) => t.Category)).sort();
    const people = uniq((state.tx || []).map((t) => t.Person).concat(state.settings.people || [])).sort();
    const accounts = uniq((state.accounts || []).map((a) => a.Account).concat((state.tx || []).map((t) => t.Account)).concat((state.bills || []).map((b) => b.Account))).sort();

    if ($("bkOldCat") && (force || !$("bkOldCat").options.length)) fillSelectWithBlank($("bkOldCat"), catsAll, "(choose)");

    const oldCat = $("bkOldCat") ? $("bkOldCat").value || "" : "";
    const catMatchesCount = (state.tx || []).filter((t) => (!catType || t.Type === catType) && String(t.Category || "") === oldCat).length;
    if ($("bkCatCount")) $("bkCatCount").textContent = String(catMatchesCount);

    const catsForSub = uniq((state.tx || []).filter((t) => !subType || t.Type === subType).map((t) => t.Category)).sort();
    if ($("bkSubCat") && (force || !$("bkSubCat").options.length)) fillSelectWithBlank($("bkSubCat"), catsForSub, "(choose)");

    const subCat = $("bkSubCat") ? $("bkSubCat").value || "" : "";
    const subs = uniq((state.tx || []).filter((t) => (!subType || t.Type === subType) && String(t.Category || "") === subCat).map((t) => t.Subcategory)).sort();
    if ($("bkOldSub")) fillSelectWithBlank($("bkOldSub"), subs, "(choose)");

    const oldSub = $("bkOldSub") ? $("bkOldSub").value || "" : "";
    const subMatchesCount = (state.tx || []).filter((t) => (!subType || t.Type === subType) && String(t.Category || "") === subCat && String(t.Subcategory || "") === oldSub).length;
    if ($("bkSubCount")) $("bkSubCount").textContent = String(subMatchesCount);

    if ($("bkOldAcc") && (force || !$("bkOldAcc").options.length)) fillSelectWithBlank($("bkOldAcc"), accounts, "(choose)");
    if ($("bkOldPerson") && (force || !$("bkOldPerson").options.length)) fillSelectWithBlank($("bkOldPerson"), people, "(choose)");

    const oldAcc = $("bkOldAcc") ? $("bkOldAcc").value || "" : "";
    const accCount = (state.tx || []).filter((t) => String(t.Account || "") === oldAcc).length + (state.bills || []).filter((b) => String(b.Account || "") === oldAcc).length;
    if ($("bkAccCount")) $("bkAccCount").textContent = String(accCount);

    const oldPerson = $("bkOldPerson") ? $("bkOldPerson").value || "" : "";
    const personCount = (state.tx || []).filter((t) => String(t.Person || "") === oldPerson).length;
    if ($("bkPersonCount")) $("bkPersonCount").textContent = String(personCount);

    if ($("bulkMsg")) $("bulkMsg").textContent = "";
  }

  function applyRenameCategory() {
    const type = $("bkCatType") ? $("bkCatType").value || "" : "";
    const oldCat = $("bkOldCat") ? $("bkOldCat").value || "" : "";
    const newCat = String($("bkNewCat")?.value || "").trim();
    if (!oldCat) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Pick an old category.</span>`; return; }
    if (!newCat) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Type a new category.</span>`; return; }

    let n = 0;
    for (const t of state.tx || []) {
      if (type && t.Type !== type) continue;
      if (String(t.Category || "") === oldCat) { t.Category = newCat; n++; }
    }
    for (const b of state.budgets || []) {
      if (type && b.Type !== type) continue;
      if (String(b.Category || "") === oldCat) b.Category = newCat;
    }

    if ($("bkNewCat")) $("bkNewCat").value = "";
    rebuildDropdowns();
    renderBudgets();
    renderOverview();
    markDirty(true);
    renderTx();
    refreshToday();
    if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="ok">Renamed.</span> Updated ${n} transaction(s).`;
  }

  function applyRenameSubcategory() {
    const type = $("bkSubType") ? $("bkSubType").value || "" : "";
    const cat = $("bkSubCat") ? $("bkSubCat").value || "" : "";
    const oldSub = $("bkOldSub") ? $("bkOldSub").value || "" : "";
    const newSub = String($("bkNewSub")?.value || "").trim();
    if (!cat) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Pick a category.</span>`; return; }
    if (!oldSub) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Pick an old subcategory.</span>`; return; }
    if (!newSub) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Type a new subcategory.</span>`; return; }

    let n = 0;
    for (const t of state.tx || []) {
      if (type && t.Type !== type) continue;
      if (String(t.Category || "") === cat && String(t.Subcategory || "") === oldSub) { t.Subcategory = newSub; n++; }
    }

    if ($("bkNewSub")) $("bkNewSub").value = "";
    rebuildDropdowns();
    renderOverview();
    renderTx();
    refreshToday();
    if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="ok">Renamed.</span> Updated ${n} transaction(s).`;
  }

  function applyRenameAccount() {
    const oldAcc = $("bkOldAcc") ? $("bkOldAcc").value || "" : "";
    const newAcc = String($("bkNewAcc")?.value || "").trim();
    if (!oldAcc) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Pick an old account.</span>`; return; }
    if (!newAcc) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Type a new account name.</span>`; return; }

    let n = 0;
    for (const t of state.tx || []) {
      if (String(t.Account || "") === oldAcc) { t.Account = newAcc; n++; }
    }
    for (const b of state.bills || []) {
      if (String(b.Account || "") === oldAcc) b.Account = newAcc;
    }
    for (const a of state.accounts || []) {
      if (String(a.Account || "") === oldAcc) a.Account = newAcc;
    }

    if ($("bkNewAcc")) $("bkNewAcc").value = "";
    mergeAccountsByName();
    rebuildDropdowns();
    renderBills();
    renderAccounts();
    renderTx();
    refreshToday();
    if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="ok">Renamed.</span> Updated ${n} transaction(s) + settings.`;
  }

  function applyRenamePerson() {
    const oldP = $("bkOldPerson") ? $("bkOldPerson").value || "" : "";
    const newP = String($("bkNewPerson")?.value || "").trim();
    if (!oldP) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Pick an old person.</span>`; return; }
    if (!newP) { if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="err">Type a new person name.</span>`; return; }

    let n = 0;
    for (const t of state.tx || []) {
      if (String(t.Person || "") === oldP) { t.Person = newP; n++; }
    }

    const ppl = uniq((state.settings.people || []).map((x) => (x === oldP ? newP : x)).concat([newP]));
    state.settings.people = ppl;

    if ($("bkNewPerson")) $("bkNewPerson").value = "";
    rebuildDropdowns();
    renderTx();
    if ($("bulkMsg")) $("bulkMsg").innerHTML = `<span class="ok">Renamed.</span> Updated ${n} transaction(s).`;
  }

  /* ============================
     Goals UI
  ============================ */
  function addGoal() {
    if (!state.loaded) return;
    state.goals.push({ GoalName: "New Goal", TargetAmount: 0, CurrentAmount: 0, Notes: "", Active: "Y" });
    renderGoalsEditor();
    if ($("goalsMsg")) $("goalsMsg").innerHTML = `<span class="ok">Added.</span>`;
  }

  function renderGoalsEditor() {
    if (!state.loaded) return;
    const el = $("goalsEditor");
    if (!el) return;

    if (!(state.goals || []).length) {
      el.innerHTML = `<div class="note">No goals yet. Add one like Emergency Fund, Move Fund, Investing Target.</div>`;
      return;
    }

    el.innerHTML = `
      <div class="tableWrap">
        <table class="tytbl">
          <thead>
            <tr>
              <th style="min-width:220px">Goal</th>
              <th class="num" style="min-width:160px">Target</th>
              <th class="num" style="min-width:160px">Current</th>
              <th style="min-width:260px">Notes</th>
              <th style="min-width:110px">Active</th>
              <th style="min-width:110px"></th>
            </tr>
          </thead>
          <tbody>
            ${(state.goals || [])
              .map((g, idx) => {
                const pct = g.TargetAmount > 0 ? Math.max(0, Math.min(1, num(g.CurrentAmount) / num(g.TargetAmount))) : 0;
                const p = Math.round(pct * 100);
                return `
                <tr data-goal-idx="${idx}" class="${String(g.Active || "Y").toUpperCase() === "N" ? "dim" : ""}">
                  <td class="wrap">
                    <input data-goal-field="GoalName" value="${escapeAttr(g.GoalName || "")}" style="width:100%">
                    <div class="sub" style="margin-top:6px">
                      <div class="bar"><div style="width:${p}%"></div></div>
                      <div class="sub">${p}%</div>
                    </div>
                  </td>
                  <td class="num"><input data-goal-field="TargetAmount" type="number" step="0.01" value="${escapeAttr(num(g.TargetAmount))}" style="width:140px;text-align:right"></td>
                  <td class="num"><input data-goal-field="CurrentAmount" type="number" step="0.01" value="${escapeAttr(num(g.CurrentAmount))}" style="width:140px;text-align:right"></td>
                  <td class="wrap"><input data-goal-field="Notes" value="${escapeAttr(g.Notes || "")}" style="width:100%"></td>
                  <td>
                    <select data-goal-field="Active">
                      <option value="Y" ${String(g.Active || "Y").toUpperCase() === "Y" ? "selected" : ""}>Y</option>
                      <option value="N" ${String(g.Active || "Y").toUpperCase() === "N" ? "selected" : ""}>N</option>
                    </select>
                  </td>
                  <td><button class="danger mini" type="button" data-action="del-goal" data-goal-idx="${idx}">Remove</button></td>
                </tr>
              `;
              })
              .join("")}
          </tbody>
        </table>
      </div>
    `;
    if ($("goalsMsg")) $("goalsMsg").textContent = "";
  }

  /* ============================
     GPT UI
  ============================ */
  function buildGptPack() {
    if (typeof buildGptPackCore === "function") {
      const res = buildGptPackCore();
      if (typeof res === "string" && $("gptOut")) $("gptOut").value = res;
      return;
    }
    if ($("gptOut")) $("gptOut").value = "buildGptPack is not available (core missing).";
  }

  async function copyGptPack() {
    const txt = $("gptOut") ? $("gptOut").value || "" : "";
    if (!txt.trim()) return;
    try {
      await navigator.clipboard.writeText(txt);
    } catch (e) {
      try {
        $("gptOut")?.focus();
        $("gptOut")?.select();
        document.execCommand("copy");
      } catch (e2) {}
    }
  }

  function loadDemo() {
    // prefer remote demo CSV so it's always the same as your published sample
    loadDemoFromUrl(DEMO_CSV_URL, true);
  }

  /* ============================
     Legacy inline hooks (kept)
  ============================ */
  function importCsvFile(input) {
    try {
      const f = input && input.files && input.files[0];
      if (!f) return;
      const r = new FileReader();
      r.onload = () => {
        try {
          setDemoMode(false);
          loadFromMaster(String(r.result || ""));
          markDirty(true);
    markDirty(true);
    markDirty(true);
    markDirty(true);
    markDirty(true);
    markDirty(true);
    afterLoad();
        } catch (err) {
          console.error(err);
          if ($("importMsg")) $("importMsg").innerHTML = `<span class="err">Import failed:</span> ${escapeHtml(err?.message || String(err))}`;
          showTab("import");
          alert("Import failed. Open Console for details.");
        }
      };
      r.onerror = () => {
        if ($("importMsg")) $("importMsg").innerHTML = `<span class="err">Could not read file.</span>`;
      };
      r.readAsText(f);
    } catch (err) {
      console.error(err);
      if ($("importMsg")) $("importMsg").innerHTML = `<span class="err">${escapeHtml(err?.message || String(err))}</span>`;
    }
  }

  /* ============================
     Expose functions for inline onclick
  ============================ */
  
  /* ============================
     v5: export wrappers (mark exported)
  ============================ */
  function downloadMaster(){
    try{
      downloadMasterCore();
      markExported();
    }catch(e){
      console.error(e);
    }
  }
  function downloadTxOnly(){
    try{
      downloadTxOnlyCore();
      markExported();
    }catch(e){
      console.error(e);
    }
  }

Object.assign(window, {
    routeToTab,
    showTab,

    renderAll,
    afterLoad,
    restoreLastSession,
    dismissRestore,

    saveRules,

    submitExpense,
    submitIncome,
    clearExpense,
    clearIncome,
    cancelPendingExpense,
    overridePendingExpense,

    renderTx,
    clearTxFilters,
    openEditById,
    closeEdit,
    saveEdit,
    overrideSaveEdit,
    deleteEdit,

    renderAccounts,
    toggleAddAccountForm,
    confirmAddAccount,

    renderReconcile,
    runReconcile,
    resetReconcile,

    recApplyFilters,
    recClearFilters,

    renderBudgets,
    addBudgetRow,

    renderBills,
    addBill,

    renderMove,
    addMoveItem,

    renderGrow,
    saveGrow,
    quickAddInvestDeposit,
    quickGoBudgets,
    quickGoExpense,

    refreshToday,

    rebuildBulkUI,
    applyRenameCategory,
    applyRenameSubcategory,
    applyRenameAccount,
    applyRenamePerson,

    renderGoalsEditor,
    addGoal,

    downloadMaster: downloadMasterCore,
    downloadTxOnly: downloadTxOnlyCore,

    buildGptPack,
    copyGptPack,

    loadDemo,

    // legacy
    importCsvFile
  });

  // extra legacy aliases commonly used in old inline buttons
  window.goTab = window.goTab || window.routeToTab;
  window.openTab = window.openTab || window.routeToTab;
  window.switchTab = window.switchTab || window.routeToTab;

  // inline expense quick buttons (Add Expense header)
  window.quickPresetEatOut = window.quickPresetEatOut || quickPresetEatOut;
  window.quickPresetGrocery = window.quickPresetGrocery || quickPresetGrocery;
  window.copyLastSimilar = window.copyLastSimilar || copyLastSimilar;
  window.setExpenseToday = window.setExpenseToday || setExpenseToday;

  // Boot: be resilient even if other scripts interfere with DOMContentLoaded.
  // init() is idempotent (guarded by TYBH.ui._initDone), so it is safe to call multiple times.
  function boot_(){
    try{ init(); }catch(e){ try{ console.error("TYBH boot failed", e); }catch(_e){} }
  }

  // Always try once ASAP (covers edge cases where DOMContentLoaded listeners don't run)
  try{ setTimeout(boot_, 0); }catch(_e){}

  // Standard hooks
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot_, { once: true });
  } else {
    boot_();
  }
  try{ window.addEventListener("load", boot_, { once: true }); }catch(_e){}
})();
